import * as angular from "angular";
import * as _ from "lodash";
import {LocationType} from "../../commons/types/location.type";
import {FulfillmentStepStatusType} from "../types/fulfillment-step-status.type";
import {QuoteType} from "../types/quote.type";
import {FulfillmentFilterPayloadModel} from "../models/fulfillment-filter-payload.model";
import {CancellationReasonVisibilitiesType} from "../../cancellation-reasons/types/cancellationReasonVisibilities.type";
import {FulfillmentPackageSplitType} from "../types/fulfillment-package-split.type";
import {FulfillmentStepModel} from "../models/fulfillment-step.model";
import {IQService} from "angular";
import {SplitService} from "../../commons/services/split-service.service";
import {ThreePLProviderType} from "../../threePL/types/threePL-provider.type";
import {AttachmentsService} from "../../attachments/services/attachments-service.service";
import {DeliveriesService} from "../../deliveries/services/deliveries-service.service";
import {SiteContextService} from "../../commons/services/site-context.service";
import {FulfillmentAlertsService} from "./fulfillment-alerts.service";
import {FulfillmentService} from "./fulfillment-service.service";
import {BranchModel} from "../../branches/models/branch.model";
import {CommonsService} from "../../commons/services/commons-service.service";
import {DispatchTimeWindowMethodType} from "../types/dispatch-time-window-method.type";
import {FulfillmentStepType} from "../types/fulfillment-step.type";
import {ActionReasonEnum} from "../../action-reasons/enums/action-reason.enum";
import {ActionReasonVisibilityEnum} from "../../action-reasons/enums/action-reason-visibility.enum";
import {ActionReasonModel} from "../../action-reasons/models/action-reason.model";
import {ActionReasonEntityEnum} from "../../action-reasons/enums/action-reason-entity.enum";
import {FulfillmentStepService} from "./fulfillment-step-service.service";

export class FulfillmentDialogService {

  public locationTypes: typeof LocationType = LocationType;
  private servicesRef: any;

  /* @ngInject */
  constructor(private $mdDialog, private fulfillmentService: FulfillmentService, private moment, private $steps,
              private fulfillmentAlertsService: FulfillmentAlertsService, private attachmentsService: AttachmentsService, private commonsConstants,
              private splitService: SplitService, private $q: IQService, private $infiniteScroll, private fulfillmentStepService: FulfillmentStepService,
              private $delivery, private siteContextService: SiteContextService) {
    this.servicesRef = this.$delivery();
  }

  selectSteps(from, to, excludeIds?, fromLocationIds?, toLocationIds?, event?, supplyAccountIds?: string[]) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/select-steps-dialog.html').default,
      controller: function ($scope) {
        $scope.searchTerm = undefined;
        $scope.selectedSteps = [];

        const loadLimit = 20;
        const stepsRef = self.$steps();

        $scope._getInfiniteScrollConfig = () => {
          const payload: FulfillmentFilterPayloadModel = {
            stepFilter: {
              from: from,
              to: to,
              excludeIds: excludeIds,
              fromLocationTypes: [self.locationTypes.DEPOT],
              toLocationTypes: [self.locationTypes.DEPOT],
              fromLocationIds: fromLocationIds,
              toLocationIds: toLocationIds,
              statuses: [FulfillmentStepStatusType.Pending],
              supplyAccountIds: supplyAccountIds
            },
            searchTerm: $scope.searchTerm
          }
          return {data: payload, getFullData: true};
        }

        $scope.infiniteScroll = self.$infiniteScroll(stepsRef, loadLimit, $scope._getInfiniteScrollConfig());

        $scope.cancel = self.$mdDialog.cancel;
        // ******************************
        // External methods
        // ******************************

        $scope.onSelectStepsChanged = (selectedSteps) => {
          $scope.selectedSteps = selectedSteps;
        }

        $scope.onQueryStringChange = (searchTerm) => {
          $scope.searchTerm = searchTerm;
        }

        $scope._query = () => {
          $scope.infiniteScroll.reload($scope._getInfiniteScrollConfig());
        }

        // ******************************
        //        Private methods
        // ******************************

        $scope.onSubmit = (form) => {
          self.$mdDialog.hide($scope.selectedSteps);
        };
      },
      targetEvent: event,
      clickOutsideToClose: false
    })
  }

  splitStep(step, stepNumber, event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/split-step.html').default,
      controller: function ($scope) {
        $scope.splitSteps = [];
        $scope.step = angular.copy(step);
        $scope.stepNumber = stepNumber;
        $scope.locationTypes = [self.locationTypes.DEPOT, self.locationTypes.CUSTOM];
        $scope.customer = undefined;

        $scope.payload = {
          location: {
            id: undefined,
            locationType: $scope.locationTypes[0],
            address: undefined
          },
          contact: undefined
        }

        $scope.cancel = self.$mdDialog.cancel;

        // ******************************
        // External methods
        // ******************************

        $scope.onChangeLocationType = (type) => {
          $scope.payload.location.address = undefined;
          if (!_.isEqual(type, 'CUSTOM')) {
            $scope.customer = undefined;
            $scope.payload.contact = undefined;
          } else {
            $scope.payload.contact = {};
          }
          $scope.payload.location.locationType = type;
        }

        $scope.onDepotSelect = (depot) => {
          $scope.payload.location.id = depot.id;
          $scope.payload.location.address = depot.address;
        }

        $scope.onSearchCustomerChange = (searchText) => {
          if (_.isUndefined($scope.payload.contact)) {
            $scope.payload.contact = {};
          }
          const customerName = $scope._getCustomerName($scope.customer);

          if (!searchText || customerName !== searchText) {
            $scope.customer = undefined;
            $scope.payload.contact.name = searchText;
          }
          if (searchText === '') {
            $scope.payload.contact = undefined;
            $scope.payload.location.address = undefined;
          }
        }

        $scope.onCustomerSelect = (customer) => {
          $scope.customer = customer;
          $scope.customer.id = customer.id;

          if (_.isUndefined($scope.payload.contact)) {
            $scope.payload.contact = {};
          }

          $scope.payload.contact.name = $scope._getCustomerName(customer);
          $scope.payload.contact.fullName = $scope._getCustomerName(customer);
          $scope.payload.contact.firstName = customer.firstName;
          $scope.payload.contact.lastName = customer.lastName;
          $scope.payload.contact.businessName = customer.businessName;
          $scope.payload.contact.phoneNo = customer.phone;
          $scope.payload.location.address = customer.addresses[0];
        }

        $scope.onPhoneChange = (phone) => {
          $scope.payload.contact.phoneNo = phone;
        }

        $scope.onAddressSelect = (address) => {
          $scope.payload.location.address = address;
          $scope.payload.location.id = undefined;
        }

        // ******************************
        //        Private methods
        // ******************************

        $scope._getCustomerName = (customer) => {
          return customer ?
            _.get(customer, 'firstName', '') + ' ' + _.get(customer, 'lastName', '') :
            undefined;
        }

        $scope.submit = (form, isDispatch) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              $scope.splitSteps.push($scope.payload);
              self.$mdDialog.hide({splitSteps: $scope.splitSteps, isDispatch: isDispatch});
            }
          }
        };
      },
      targetEvent: event,
      clickOutsideToClose: false,
      fullscreen: true
    })
  }

  bulkDispatch(milesData?, event?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/bulk-dispatch.html').default,
      controller: function ($scope) {

        $scope.cancel = self.$mdDialog.cancel;
        $scope.milesData = milesData;

        // ******************************
        // External methods
        // ******************************

        $scope.onChangeMilesData = (milesData) => {
          $scope.milesData = milesData;
        }

        $scope.submit = () => {
          self.$mdDialog.hide($scope.milesData);
        };
      },
      targetEvent: event,
      clickOutsideToClose: false,
      fullscreen: true
    })
  }

  dispatchStep(fulfillment, stepIds, event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/dispatch-step.html').default,
      controller: function ($scope, $timeout, $translate) {
        $scope.defaultDispatchType = self.splitService.getDefaultDispatchType();
        $scope.isEnforceSequentialFulfillmentDispatch = self.splitService.getEnforceSequentialFulfillmentDispatch();
        $scope.relationsMap = {};
        $scope.stepsBlockedByIds = {};
        $scope.stepsBlockedByIdsMap = {};
        $scope.stepsDispatchData = {};

        $scope.onLocationTypeChange = (locationType, location, step) => {
          if (location === 'pickup') {
            $scope.stepsDispatchData[step.id].pickupLocationType = locationType;
          }

          if (location === 'dropoff') {
            $scope.stepsDispatchData[step.id].dropoffLocationType = locationType;
          }
        }

        $scope.onAccountSelect = (account, location, step, notBefore, notAfter) => {
          if (location === 'pickup') {
            if ($scope.stepsDispatchData[step.id].pickupLocationId === account?.id) {
              return;
            }

            if (!account) {
              $scope.stepsDispatchData[step.id].pickupLocationId = undefined;
              $scope.stepsDispatchData[step.id].pickupLocationType = undefined;
              $scope.stepsDispatchData[step.id].pickupLocationAddress = undefined;
            } else {
              $scope.stepsDispatchData[step.id].pickupLocationId = account.id;
              $scope.stepsDispatchData[step.id].pickupLocationAddress = account.address;
            }
          }

          if (location === 'dropoff') {
            if ($scope.stepsDispatchData[step.id].dropoffLocationId === account?.id) {
              return;
            }

            if (!account) {
              $scope.stepsDispatchData[step.id].dropoffLocationId = undefined;
              $scope.stepsDispatchData[step.id].dropoffLocationType = undefined;
              $scope.stepsDispatchData[step.id].dropoffLocationAddress = undefined;
            } else {
              $scope.stepsDispatchData[step.id].dropoffLocationId = account.id;
              $scope.stepsDispatchData[step.id].dropoffLocationAddress = account.address;
            }
          }


          if (($scope.stepsDispatchData[step.id].pickupLocationId || !!step.pickup?.location?.address) && ($scope.stepsDispatchData[step.id].dropoffLocationId || !!step.destination?.location?.address)) {
            $scope.getStepDispatchTimeRanges(step, notBefore, notAfter);
          }
        }

        $scope.onDepotSelect = (depot, location, step, notBefore, notAfter) => {

          if (location === 'pickup') {
            if ($scope.stepsDispatchData[step.id].pickupLocationId === depot?.id) {
              return;
            }

            if (!depot) {
              $scope.stepsDispatchData[step.id].pickupLocationId = undefined;
              $scope.stepsDispatchData[step.id].pickupLocationType = undefined;
              $scope.stepsDispatchData[step.id].pickupLocationAddress = undefined;
            } else {
              $scope.stepsDispatchData[step.id].pickupLocationId = depot.id;
              $scope.stepsDispatchData[step.id].pickupLocationAddress = depot.address;
            }

          }

          if (location === 'dropoff') {
            if ($scope.stepsDispatchData[step.id].dropoffLocationId === depot?.id) {
              return;
            }

            if (!depot) {
              $scope.stepsDispatchData[step.id].dropoffLocationId = undefined;
              $scope.stepsDispatchData[step.id].dropoffLocationType = undefined;
              $scope.stepsDispatchData[step.id].dropoffLocationAddress = undefined;
            } else {
              $scope.stepsDispatchData[step.id].dropoffLocationId = depot.id;
              $scope.stepsDispatchData[step.id].dropoffLocationAddress = depot.address;
            }
          }

          if (($scope.stepsDispatchData[step.id].pickupLocationId || !!step.pickup?.location?.address) && ($scope.stepsDispatchData[step.id].dropoffLocationId || !!step.destination?.location?.address)) {
            $scope.getStepDispatchTimeRanges(step, notBefore, notAfter);
          }
        }

        $scope.onCustomerSelect = (customer, location, step, notBefore, notAfter) => {
          if (location === 'pickup') {
            if ($scope.stepsDispatchData[step.id].pickupLocationId === customer?.id) {
              return;
            }

            if (!customer) {
              $scope.stepsDispatchData[step.id].pickupLocationId = undefined;
              $scope.stepsDispatchData[step.id].pickupLocationType = undefined;
              $scope.stepsDispatchData[step.id].pickupLocationAddress = undefined;
            } else {
              $scope.stepsDispatchData[step.id].pickupLocationId = customer.id;
              $scope.stepsDispatchData[step.id].pickupLocationAddress = customer.addresses[0];
            }
          }

          if (location === 'dropoff') {
            if ($scope.stepsDispatchData[step.id].dropoffLocationId === customer?.id) {
              return;
            }

            if (!customer) {
              $scope.stepsDispatchData[step.id].dropoffLocationId = undefined;
              $scope.stepsDispatchData[step.id].dropoffLocationType = undefined;
              $scope.stepsDispatchData[step.id].dropoffLocationAddress = undefined;
            } else {
              $scope.stepsDispatchData[step.id].dropoffLocationId = customer.id;
              $scope.stepsDispatchData[step.id].dropoffLocationAddress = customer.addresses[0];
            }
          }

          if (($scope.stepsDispatchData[step.id].pickupLocationId || !!step.pickup?.location?.address) && ($scope.stepsDispatchData[step.id].dropoffLocationId || !!step.destination?.location?.address)) {
            $scope.getStepDispatchTimeRanges(step, notBefore, notAfter);
          }
        }

        $scope.fulfillmentSteps = _.filter(fulfillment.fulfillmentSteps, (s) => {
          return (s.status !== FulfillmentStepStatusType.Completed) &&
            (s.status !== FulfillmentStepStatusType.Failed) &&
            (s.status !== FulfillmentStepStatusType.OnHold) &&
            (s.status !== FulfillmentStepStatusType.Canceled) &&
            (_.isUndefined(stepIds) || _.includes(stepIds, s.id));
        })
        $scope.fulfillmentLinesInfoMap = _.keyBy(fulfillment.linesInfo, 'id');
        _.forEach($scope.fulfillmentSteps, (step) => {
          if (!$scope.fulfillmentLinesInfoMap[step.fulfillmentLineId]) {
            $scope.fulfillmentLinesInfoMap[step.fulfillmentLineId] = {
              displayStatus: step.displayStatus,
              programName: step.programName
            };
          }
        });
        $scope.fulfillmentStepIds = _.map($scope.fulfillmentSteps, 'id');
        if (!!$scope.fulfillmentStepIds?.length) {
          self.fulfillmentService.getRelations(fulfillment.id, $scope.fulfillmentStepIds)
            .then((relations) => {
              _.forEach(relations, (r) => {
                if (r.sourceIds?.length && r.targetIds.length) {
                  _.forEach(r.targetIds, targetId => {
                    if (!$scope.relationsMap[targetId]) {
                      $scope.relationsMap[targetId] = {};
                    }
                    if (!$scope.relationsMap[targetId].blockedBy) {
                      $scope.relationsMap[targetId].blockedBy = []
                    }
                    _.forEach(r.sourceIds, sourceId => {
                      $scope.relationsMap[targetId].blockedBy.push(sourceId);
                    })
                  })
                }
              })
              _.forOwn($scope.relationsMap, (relation, stepId) => {
                $scope.stepsBlockedByIds[stepId] = [];
                $scope.stepsBlockedByIdsMap[stepId] = [];
                _.forEach(relation.blockedBy, i => {
                  const stepIndex = _.findIndex(fulfillment.fulfillmentSteps, (s: any) => {
                    return s.id === i;
                  })
                  $scope.stepsBlockedByIds[stepId].push(stepIndex + 1);
                  $scope.stepsBlockedByIdsMap[stepId].push(fulfillment.fulfillmentSteps[stepIndex].id);
                })
                $scope.stepsBlockedByIds[stepId] = _.sortBy($scope.stepsBlockedByIds[stepId]);
              })
            })
        }
        $scope.selectedStepsIds = {};
        $scope.stepOptions = {};
        $scope.stepIds = stepIds;
        // $scope.stepsDispatchData = {};
        $scope.notBeforeToday = self.moment().startOf('day').valueOf();
        $scope.isFinished = false;
        $scope.timeZoneId = self.splitService.getTimeZone();
        $scope.todayDate = self.moment().valueOf();
        $scope.isDispatching = false;
        $scope.allowDayLongDispatchWindow = self.siteContextService.getSiteInfo().allowDayLongDispatchWindow;
        $scope.enforceTimeSpecificDispatchWindow = self.siteContextService.getSiteInfo().enforceTimeSpecificDispatchWindow;
        $scope.defaultDispatchStepTimeWindowMethod = self.siteContextService.getSiteInfo().omsOrderCustomizedFields.defaultDispatchStepTimeWindowMethod;
        $scope.fulfillmentStepType = FulfillmentStepType;


        $scope.cancel = self.$mdDialog.cancel;
        // ******************************
        // External methods
        // ******************************

        $scope.isDispatchDisabled = (step) => {
          if (!$scope.isEnforceSequentialFulfillmentDispatch || !$scope.stepsBlockedByIdsMap[step.id]?.length) {
            return false;
          } else {
            let shouldDisable = false;
            $scope.stepsBlockedByIdsMap[step.id]?.forEach((id) => {
              const originalStepBlocking = fulfillment.fulfillmentSteps?.find((s) => {
                return s.id === id;
              })
              const isDispatched = $scope.stepsDispatchData[id]?.dispatched || originalStepBlocking?.status === FulfillmentStepStatusType.Scheduled;
              const isSelected = $scope.selectedStepsIds[$scope.stepsBlockedByIdsMap[step.id]];
              if (!isSelected && !isDispatched) {
                shouldDisable = true;
              }
            })
            return shouldDisable;
          }
        }

        $scope.calculateInitialStepTimestamp = (step, option) => {

          if (option === 'pickupNotBefore') {
            if (!_.get(step, 'pickup')) {
              return self.moment().startOf('hour').valueOf();
            } else {
              if (step.pickup?.notBefore) {
                return step.pickup.notBefore;
              } else if (step.destination?.notBefore) {
                return step.destination.notBefore
              }
            }
          } else if (option === 'pickupNotAfter') {
            if (!_.get(step, 'pickup')) {
              return self.moment().endOf('hour').valueOf();
            } else {
              if (step.pickup?.notAfter) {
                return step.pickup.notAfter;
              } else if (step.destination?.notBefore) {
                return step.destination.notBefore;
              }
            }
          } else if (option === 'destinationNotBefore') {
            if (step.destination?.notBefore) {
              return step.destination.notBefore;
            } else if (step.pickup?.notAfter) {
              return step.pickup.notAfter
            }
          } else {
            if (step.destination?.notAfter) {
              return step.destination.notAfter;
            } else if (step.pickup?.notAfter) {
              return step.pickup.notAfter
            }
          }
          return self.moment().startOf('hour').valueOf();

        }

        $scope.stepSelectedDate = (step, option, index) => {

          if (option === 'pickupDate' && _.get(step, 'pickup')) {
            if (step.pickup?.notBefore) {
              return self.moment(step.pickup.notBefore).startOf('day').valueOf();
            } else if (step.destination?.notBefore) {
              return self.moment(step.destination.notBefore).startOf('day').valueOf();
            } else if (index > 0) {
              // return this.moment($scope.stepsDispatchData[fulfillment.fulfillmentSteps[index - 1].id].pickupDate).valueOf()
              return self.moment($scope.stepsDispatchData[step.id].pickupDate).valueOf()
            } else {
              return self.moment().startOf('day').valueOf();
            }
          } else if (option === 'pickupDate' && !_.get(step, 'pickup')) {
            if (step.destination?.notBefore) {
              return self.moment(step.destination.notBefore).startOf('day').valueOf();
            } else if (index > 0) {
              // return this.moment($scope.stepsDispatchData[fulfillment.fulfillmentSteps[index - 1].id].pickupDate).valueOf()
              return self.moment($scope.stepsDispatchData[step.id].pickupDate).valueOf()
            } else {
              return self.moment().startOf('day').valueOf();
            }
          }

          if (option === 'destinationDate') {
            if (step.destination?.notBefore) {
              return self.moment(step.destination.notBefore).endOf('day').valueOf();
            } else if (step.pickup?.notBefore) {
              return self.moment(step.pickup.notBefore).endOf('day').valueOf();
            } else if (index > 0) {
              // return this.moment($scope.stepsDispatchData[fulfillment.fulfillmentSteps[index - 1].id].destinationDate).valueOf();
              return self.moment($scope.stepsDispatchData[step.id].destinationDate).valueOf();
            } else {
              return self.moment().endOf('day').valueOf();
            }
          }

        }

        $scope._getStepDataOption = (step, notBefore, notAfter) => {

          if ((((!$scope.stepsDispatchData[step.id].pickupLocationId && !step.pickup?.location?.address && step.type !== 'Operation') || (!$scope.stepsDispatchData[step.id].dropoffLocationId && !step.destination?.location?.address)))) {
            return;
          }

          let overridePickupLocation, overrideDestinationLocation, payload;
          if (!!$scope.stepsDispatchData[step.id].pickupLocationId) {
            overridePickupLocation = {
              id: $scope.stepsDispatchData[step.id].pickupLocationId,
              locationType: $scope.stepsDispatchData[step.id].pickupLocationType,
              address: $scope.stepsDispatchData[step.id].pickupLocationAddress
            }
          }

          if (!!$scope.stepsDispatchData[step.id].dropoffLocationId) {
            overrideDestinationLocation = {
              id: $scope.stepsDispatchData[step.id].dropoffLocationId,
              locationType: $scope.stepsDispatchData[step.id].dropoffLocationType,
              address: $scope.stepsDispatchData[step.id].dropoffLocationAddress
            }
          }

          if (!!overridePickupLocation || overrideDestinationLocation) {
            payload = {
              overridePickupLocation,
              overrideDestinationLocation
            }
          }

          let dispatchDataRef = angular.copy($scope.stepsDispatchData[step.id]);

          if (dispatchDataRef.optionsType === "FreeStyle") {
            if (dispatchDataRef.isPerServiceOrTask === 'perTask') {
              dispatchDataRef.pickupFullDayTimeWindow = dispatchDataRef.defaultDispatchByTaskFullDaySettings.defaultFullDayForPickupTask;
              dispatchDataRef.destinationFullDayTimeWindow = dispatchDataRef.defaultDispatchByTaskFullDaySettings.defaultFullDayForDestinationTask;


              dispatchDataRef.pickupNotBefore = self.moment(dispatchDataRef.pickupDate).startOf('day').valueOf();
              dispatchDataRef.pickupNotAfter = self.moment(dispatchDataRef.pickupDate).endOf('day').valueOf();

              dispatchDataRef.destinationNotBefore = self.moment(dispatchDataRef.destinationDate).startOf('day').valueOf();
              dispatchDataRef.destinationNotAfter = self.moment(dispatchDataRef.destinationDate).endOf('day').valueOf();
            } else {
              dispatchDataRef.destinationFullDayTimeWindow = dispatchDataRef.defaultFullDayForServiceDispatch;

              dispatchDataRef.destinationNotBefore = self.moment(dispatchDataRef.destinationDate).startOf('day').valueOf();
              dispatchDataRef.destinationNotAfter = self.moment(dispatchDataRef.destinationDate).endOf('day').valueOf();
            }

            return;
          }

          if ($scope.stepsDispatchData[step.id]) {
            $scope.stepsDispatchData[step.id].disabled = true;
          }


          return self.fulfillmentService.getStepDispatchTimeRanges(fulfillment.id, step.id, undefined, undefined, notBefore, notAfter, payload, $scope.stepsDispatchData[step.id].optionsType, true)
            .then((res: any) => {

              // dispatchDataRef.isSectionOpen = !_.isUndefined(_.get($scope.stepsDispatchData[step.id], 'isSectionOpen')) ? $scope.stepsDispatchData[step.id].isSectionOpen : (_.get(stepIds, 'length') ? _.includes(stepIds, step.id) && !step.pickup?.schedulingRequired && !step.destination?.schedulingRequired : !step.pickup?.schedulingRequired && !step.destination?.schedulingRequired);
              dispatchDataRef.destinationMinimumDate = _.get(dispatchDataRef, 'destinationMinimumDate', (dispatchDataRef.isPerServiceOrTask === 'perTask' ? dispatchDataRef.pickupDate : (dispatchDataRef.index > 0 ? ($scope.stepsDispatchData[fulfillment.fulfillmentSteps[dispatchDataRef.index - 1]?.id]?.destinationDate || $scope.stepsDispatchData[step.id]?.destinationDate) : undefined)));
              dispatchDataRef.supplierName = "Bringoz";
              dispatchDataRef.provider = "Bringoz";
              dispatchDataRef.subType = "Dispatch";

              dispatchDataRef.pickupTimeRanges = _.chain(res.stepDispatchOptions)
                .flatMap('quoteDetails')
                .filter(details => {
                  // return details.type === 'TimeSlotPerTask'
                  return details.type === (dispatchDataRef.isPerServiceOrTask === 'perTask' ? QuoteType.TimeSlotPerTask : QuoteType.TimeSlot)
                })
                .flatMap('pickupQuotes')

                .map(quote => {
                  return {notBefore: _.get(quote, 'notBefore'), notAfter: _.get(quote, 'notAfter') || (_.get(quote, 'notBefore') + _.get(quote, 'duration', 0))}
                })
                .filter(timeSlot => {
                  return $scope.isTimeslotInRange(timeSlot, dispatchDataRef.pickupDate, (self.moment(dispatchDataRef.pickupDate).endOf('day').valueOf()));
                }).sortBy(res.stepDispatchOptions, ['notBefore'])
                .value();

              dispatchDataRef.destinationTimeRanges = _.chain(res.stepDispatchOptions)
                .flatMap('quoteDetails')
                .filter(details => {
                  // return details.type === 'TimeSlotPerTask'
                  return details.type === (dispatchDataRef.isPerServiceOrTask === 'perTask' ? QuoteType.TimeSlotPerTask : QuoteType.TimeSlot)
                })
                .flatMap('destinationQuotes')
                .map(quote => {
                  return {notBefore: _.get(quote, 'notBefore'), notAfter: _.get(quote, 'notAfter') || (_.get(quote, 'notBefore') + _.get(quote, 'duration', 0))}
                })
                .filter(timeSlot => {
                  return $scope.isTimeslotInRange(timeSlot, self.moment(dispatchDataRef.destinationDate).startOf('day').valueOf(), dispatchDataRef.destinationDate);
                }).sortBy(res.stepDispatchOptions, ['notBefore'])
                .value();

              dispatchDataRef.dynamicTimeSlotOptions = _.chain(res.stepDispatchOptions)
                .flatMap('quoteDetails')
                .filter(details => {
                  return details.type === 'DynamicTimeSlot'
                })
                .value();

              $scope.stepsDispatchData[step.id] = dispatchDataRef;
            })
            .catch(() => {
              $scope.stepsDispatchData[step.id].disabled = false;
            })
            .finally(() => {
              $scope.stepsDispatchData[step.id].disabled = false;
            })
        }

        $scope.selectPickupTimeRange = (prevStep, options, prevSelectedOption?, prevStepId?) => {
          if (prevSelectedOption && prevSelectedOption.notBefore >= prevStep.destinationNotBefore) {
            return prevSelectedOption;
          }
          if (_.isUndefined(options)) {
            return undefined;
          }
          if (!$scope.selectedStepsIds[prevStepId]) {
            return options[0];
          }
          if (!prevStep.destinationNotBefore) {
            return options[0];
          }
          for (let option of options) {
            if (option.notBefore >= prevStep.destinationNotBefore) {
              return option
            }
          }
          return undefined;
        }

        $scope.selectDestinationTimeRange = (pickupNotBefore, options, prevSelectedOption?, isPerService?) => {
          if (prevSelectedOption && prevSelectedOption.notBefore >= pickupNotBefore) {
            return prevSelectedOption;
          }
          if (_.isUndefined(options)) {
            return;
          }
          if (!pickupNotBefore && isPerService) {
            return options[0];
          }
          for (let option of options) {
            if (option.notBefore >= pickupNotBefore) {
              return option
            }
          }
          return undefined;
        }

        $scope.setStepsTimes = () => {
          let currentIndex = 0;
          _.forOwn($scope.stepsDispatchData, (value, key, index) => {
            value.pickupSelectedTimeRange = (fulfillment.fulfillmentSteps[currentIndex].pickup?.schedulingRequired && !value.pickupNotBefore && !value.pickupNotAfter) ? undefined : (currentIndex > 0 ? $scope.selectPickupTimeRange($scope.stepsDispatchData[fulfillment.fulfillmentSteps[currentIndex - 1].id], value.pickupTimeRanges, undefined, fulfillment.fulfillmentSteps[currentIndex - 1].id) : _.get(value, 'pickupTimeRanges[0]', undefined));
            value.pickupNotBefore = (fulfillment.fulfillmentSteps[currentIndex].pickup?.schedulingRequired && !value.pickupNotBefore) ?
              undefined : ((value.optionsType === QuoteType.TimeSlot && _.get(value, 'pickupTimeRanges[0].notBefore')) ? _.get(value.pickupSelectedTimeRange, 'notBefore', undefined) :
                (_.get($scope.stepsDispatchData[fulfillment.fulfillmentSteps[currentIndex].id], 'pickupNotBefore') ?
                  $scope.stepsDispatchData[fulfillment.fulfillmentSteps[currentIndex].id].pickupNotBefore : ($scope.stepsDispatchData[fulfillment.fulfillmentSteps[currentIndex].id].optionsType === 'TimeSlot' ?
                    undefined : $scope.calculateInitialStepTimestamp(fulfillment.fulfillmentSteps[currentIndex], 'pickupNotBefore'))));
            value.pickupNotAfter = (fulfillment.fulfillmentSteps[currentIndex].pickup?.schedulingRequired && !value.pickupNotAfter) ?
              undefined : ((value.optionsType === QuoteType.TimeSlot && _.get(value, 'pickupTimeRanges[0].notAfter')) ?
                _.get(value.pickupSelectedTimeRange, 'notAfter', undefined) :
                (_.get($scope.stepsDispatchData[fulfillment.fulfillmentSteps[currentIndex].id], 'pickupNotAfter') ?
                  $scope.stepsDispatchData[fulfillment.fulfillmentSteps[currentIndex].id].pickupNotAfter :
                  ($scope.stepsDispatchData[fulfillment.fulfillmentSteps[currentIndex].id].optionsType === QuoteType.TimeSlot ?
                    undefined : $scope.calculateInitialStepTimestamp(fulfillment.fulfillmentSteps[currentIndex], 'pickupNotAfter'))));
            value.destinationSelectedTimeRange =
              (fulfillment.fulfillmentSteps[currentIndex].destination?.schedulingRequired && !value.destinationNotBefore && !value.destinationNotAfter) ?
                undefined : (currentIndex > 0 ? (value.isPerServiceOrTask === 'perService' ?
                  $scope.selectDestinationTimeRange($scope.stepsDispatchData[fulfillment.fulfillmentSteps[currentIndex].id].destinationNotBefore, value.destinationTimeRanges, undefined, true) :
                  $scope.selectDestinationTimeRange(value.pickupNotBefore, value.destinationTimeRanges)) : _.get(value, 'destinationTimeRanges[0]', undefined));


            value.destinationNotBefore = (fulfillment.fulfillmentSteps[currentIndex].destination?.schedulingRequired && !value.destinationNotBefore) ?
              undefined : ((value.optionsType === QuoteType.TimeSlot) ? _.get(value.destinationSelectedTimeRange, 'notBefore', undefined) :
                (_.get($scope.stepsDispatchData[fulfillment.fulfillmentSteps[currentIndex].id], 'destinationNotBefore') ?
                  $scope.stepsDispatchData[fulfillment.fulfillmentSteps[currentIndex].id].destinationNotBefore :
                  ($scope.stepsDispatchData[fulfillment.fulfillmentSteps[currentIndex].id].optionsType === QuoteType.TimeSlot ? undefined : $scope.calculateInitialStepTimestamp(fulfillment.fulfillmentSteps[currentIndex], 'destinationNotBefore'))));


            value.destinationNotAfter = (fulfillment.fulfillmentSteps[currentIndex].destination?.schedulingRequired && !value.destinationNotAfter) ?
              undefined :
              ((value.optionsType === QuoteType.TimeSlot) ? _.get(value.destinationSelectedTimeRange, 'notAfter', undefined) :
                (_.get($scope.stepsDispatchData[fulfillment.fulfillmentSteps[currentIndex].id], 'destinationNotAfter') ? $scope.stepsDispatchData[fulfillment.fulfillmentSteps[currentIndex].id].destinationNotAfter :
                  ($scope.stepsDispatchData[fulfillment.fulfillmentSteps[currentIndex].id].optionsType === QuoteType.TimeSlot ? undefined : $scope.calculateInitialStepTimestamp(fulfillment.fulfillmentSteps[currentIndex], 'destinationNotAfter'))));


            value.isPickupDateOutOfRange = !$scope.isInDateRange(fulfillment.fulfillmentSteps[currentIndex], value.pickupNotBefore, value.pickupNotAfter, true);
            value.isDestinationDateOutOfRange = !$scope.isInDateRange(fulfillment.fulfillmentSteps[currentIndex], value.destinationNotBefore, value.destinationNotAfter, false);


            currentIndex++;
          })
        }

        $scope.onTogglePickupFullDayTimeWindow = (stepDispatchData) => {
          if (stepDispatchData.pickupFullDayTimeWindow) {
            stepDispatchData.pickupNotBefore = self.moment(stepDispatchData.pickupNotBefore).startOf('day').valueOf();
            stepDispatchData.pickupNotAfter = self.moment(stepDispatchData.pickupNotAfter).endOf('day').valueOf();
          }
        }

        $scope.onToggleDestinationFullDayTimeWindow = (stepDispatchData) => {
          if (stepDispatchData.destinationFullDayTimeWindow) {
            stepDispatchData.destinationNotBefore = self.moment(stepDispatchData.destinationNotBefore).startOf('day').valueOf();
            stepDispatchData.destinationNotAfter = self.moment(stepDispatchData.destinationNotAfter).endOf('day').valueOf();
          }
        }

        $scope.canDestinationRangeBeSelected = (step, range) => {
          return step.isPerServiceOrTask === 'perService' ?
            (step.index > 0 && $scope.stepsDispatchData[fulfillment.fulfillmentSteps[step.index - 1].id].destinationNotBefore ?
              $scope.stepsDispatchData[fulfillment.fulfillmentSteps[step.index - 1].id].destinationNotBefore > range.notBefore : false) :
            (step.pickupNotBefore ? step.pickupNotBefore > range.notBefore : true);
        }

        $scope.canPickupRangeBeSelected = (index, range, prevStepId?) => {
          return index > 0 && $scope.selectedStepsIds[prevStepId] ?
            ($scope.stepsDispatchData[fulfillment.fulfillmentSteps[index - 1].id].destinationNotBefore ? $scope.stepsDispatchData[fulfillment.fulfillmentSteps[index - 1].id].destinationNotBefore > range.notBefore : false)
            : false;
        }

        $scope.canDynamicTimeSlotOptionBeSelected = (index, option) => {
          return index > 0 ? ($scope.stepsDispatchData[fulfillment.fulfillmentSteps[index - 1].id].destinationNotBefore ? $scope.stepsDispatchData[fulfillment.fulfillmentSteps[index - 1].id].destinationNotBefore > option.pickup?.notBefore : false) : false;
        }

        $scope.getStepDispatchTimeRanges = (step, notBefore?, notAfter?, isSelectChanged?) => {
          var notBeforeCopy = angular.copy(notBefore);
          var notAfterCopy = angular.copy(notAfter);


          if (!notBeforeCopy && !notAfterCopy) {
            notBeforeCopy = $scope.stepSelectedDate(step, 'pickupDate', $scope.stepsDispatchData[step.id].index);
            notAfterCopy = $scope.stepSelectedDate(step, 'destinationDate', $scope.stepsDispatchData[step.id].index);
          }

          if ($scope.stepsDispatchData[step.id].optionsType === QuoteType.DynamicTimeSlot) {
            notBeforeCopy = self.moment($scope.stepsDispatchData[step.id].dynamicQuoteFromDate).startOf('day').valueOf();
            notAfterCopy = self.moment($scope.stepsDispatchData[step.id].dynamicQuoteToDate).endOf('day').valueOf();
            // notAfterCopy = this.moment(notBeforeCopy).add(($scope.stepsDispatchData[step.id].workingDays - 1), 'day').endOf('day').valueOf();
          }

          if (isSelectChanged && $scope.stepsDispatchData[step.id].optionsType === QuoteType.TimeSlot) {
            $scope.stepsDispatchData[step.id].disabled = true;

            notBeforeCopy = self.moment($scope.stepsDispatchData[step.id].pickupDate).startOf('day').valueOf();
            notAfterCopy = self.moment($scope.stepsDispatchData[step.id].destinationDate).endOf('day').valueOf();
          }

          return $scope._getStepDataOption(step, notBeforeCopy, notAfterCopy);
        }

        $scope.onTimeStyleChange = (step, notBefore?, notAfter?, index?) => {

          self.fulfillmentService.cancelStepDispatchTimeRange(fulfillment.id, step.id);

          $scope.stepsDispatchData[step.id].pickupLocationType = undefined;
          $scope.stepsDispatchData[step.id].pickupLocationId = undefined;
          $scope.stepsDispatchData[step.id].pickupLocationAddress = undefined;

          $scope.stepsDispatchData[step.id].dropoffLocationType = undefined;
          $scope.stepsDispatchData[step.id].dropoffLocationId = undefined;
          $scope.stepsDispatchData[step.id].dropoffLocationAddress = undefined;

          if (step.type === $scope.fulfillmentStepType.Operation) {
            $scope.stepsDispatchData[step.id].isPerServiceOrTask = DispatchTimeWindowMethodType.perService;
          } else if ($scope.stepsDispatchData[step.id].optionsType === QuoteType.DynamicTimeSlot) {
            $scope.stepsDispatchData[step.id].isPerServiceOrTask = DispatchTimeWindowMethodType.perService;
          } else {
            $scope.stepsDispatchData[step.id].isPerServiceOrTask = $scope.defaultDispatchStepTimeWindowMethod;
          }
          if ($scope.stepsDispatchData[step.id].optionsType === QuoteType.FreeStyle) {
            $scope.stepsDispatchData[step.id].pickupNotBefore = index > 0 && !$scope.isFirstTimeStampAfterSecondTimeStamp(self.moment($scope.calculateInitialStepTimestamp(step, 'pickupNotBefore')).set({
              year: self.moment(notBefore).year(),
              month: self.moment(notBefore).month(),
              date: self.moment(notBefore).date()
            }).valueOf(), $scope.stepsDispatchData[fulfillment.fulfillmentSteps[index - 1].id].destinationNotBefore) ? $scope.stepsDispatchData[fulfillment.fulfillmentSteps[index - 1].id].destinationNotBefore :
              self.moment($scope.calculateInitialStepTimestamp(step, 'pickupNotBefore')).set({
                year: self.moment(notBefore).year(),
                month: self.moment(notBefore).month(),
                date: self.moment(notBefore).date()
              }).valueOf();

            $scope.stepsDispatchData[step.id].pickupNotAfter = $scope.isFirstTimeStampAfterSecondTimeStamp(self.moment($scope.calculateInitialStepTimestamp(step, 'pickupNotAfter')).set({
              year: self.moment(notBefore).year(),
              month: self.moment(notBefore).month(),
              date: self.moment(notBefore).date()
            }).valueOf(), $scope.stepsDispatchData[step.id].pickupNotBefore) ? self.moment($scope.calculateInitialStepTimestamp(step, 'pickupNotAfter')).set({
              year: self.moment(notBefore).year(),
              month: self.moment(notBefore).month(),
              date: self.moment(notBefore).date()
            }).valueOf() : $scope.stepsDispatchData[step.id].pickupNotBefore;

            $scope.stepsDispatchData[step.id].destinationNotBefore = $scope.isFirstTimeStampAfterSecondTimeStamp(self.moment($scope.calculateInitialStepTimestamp(step, 'destinationNotBefore')).set({
              year: self.moment(notAfter).year(),
              month: self.moment(notAfter).month(),
              date: self.moment(notAfter).date()
            }).valueOf(), $scope.stepsDispatchData[step.id].pickupNotAfter) ? self.moment($scope.calculateInitialStepTimestamp(step, 'destinationNotBefore')).set({
              year: self.moment(notAfter).year(),
              month: self.moment(notAfter).month(),
              date: self.moment(notAfter).date()
            }).valueOf() : $scope.stepsDispatchData[step.id].pickupNotAfter;

            $scope.stepsDispatchData[step.id].destinationNotAfter = $scope.isFirstTimeStampAfterSecondTimeStamp(self.moment($scope.calculateInitialStepTimestamp(step, 'destinationNotAfter')).set({
              year: self.moment(notAfter).year(),
              month: self.moment(notAfter).month(),
              date: self.moment(notAfter).date()
            }).valueOf(), $scope.stepsDispatchData[step.id].destinationNotBefore) ? self.moment($scope.calculateInitialStepTimestamp(step, 'destinationNotAfter')).set({
              year: self.moment(notAfter).year(),
              month: self.moment(notAfter).month(),
              date: self.moment(notAfter).date()
            }).valueOf() : $scope.stepsDispatchData[step.id].destinationNotBefore;
          }

          if ($scope.stepsDispatchData[step.id].optionsType === QuoteType.TimeSlot) {
            $scope.getStepDispatchTimeRanges(step, notBefore, notAfter);
          }

          if ($scope.stepsDispatchData[step.id].optionsType === QuoteType.DynamicTimeSlot) {
            $scope.stepsDispatchData[step.id].dynamicQuoteFromDate = self.moment().valueOf() - $scope.stepsDispatchData[step.id].destinationDate ? self.moment().valueOf() : $scope.stepsDispatchData[step.id].destinationDate;
            $scope.stepsDispatchData[step.id].dynamicQuoteToDate = self.moment($scope.stepsDispatchData[step.id].dynamicQuoteFromDate).add(10, 'day').endOf('day').valueOf();
            $scope.getStepDispatchTimeRanges(step, notBefore, notAfter);
          }

          $scope.stepsDispatchData[step.id].isPickupDateOutOfRange = !$scope.isInDateRange(step, $scope.stepsDispatchData[step.id].pickupNotBefore, $scope.stepsDispatchData[step.id].pickupNotAfter, true);
          $scope.stepsDispatchData[step.id].isDestinationDateOutOfRange = !$scope.isInDateRange(step, $scope.stepsDispatchData[step.id].destinationNotBefore, $scope.stepsDispatchData[step.id].destinationNotAfter, false);
          $scope.setStepsTimes();

          if ($scope.stepsDispatchData[step.id].optionsType === 'FreeStyle') {
            $scope.setDestinationMinimumDate(step);
          }
        }

        $scope.isFirstTimeStampAfterSecondTimeStamp = (firstTimestamp, secondTimeStamp) => {
          return firstTimestamp > secondTimeStamp;
        }

        $scope.isTimeslotInRange = (timeslot, from, to) => {
          return self.moment(timeslot.notBefore).isBetween(from, to, null, '[]') &&
            self.moment(timeslot.notAfter || (_.get(timeslot, 'notBefore') + _.get(timeslot, 'duration', 0) ) ).isBetween(from, to, null, '[]')
        }

        (() => {
          let promises = [];
          const fulfillmentStepIds = $scope.fulfillmentSteps.map(s => s.id);

          if (!fulfillmentStepIds?.length) return;
          self.fulfillmentStepService.getFulfillmentStepSettings(fulfillmentStepIds)
            .then((settings: any[]) => {

              _.forEach($scope.fulfillmentSteps, (step, index) => {
                const stepSettings = settings.find(s => s.stepId === step.id).settings;
                $scope.stepsDispatchData[step.id] = {};
                $scope.stepsDispatchData[step.id].stepSettings = stepSettings;

                if (_.get(step, 'pickup') && !step.pickup?.schedulingRequired && !step.destination?.schedulingRequired) {
                  $scope.selectedStepsIds[step.id] = _.get(stepIds, 'length') ? _.includes(stepIds, step.id) : true;
                }
                $scope.stepsDispatchData[step.id].type = step.type;
                // $scope.stepsDispatchData[step.id].disabled = true;
                $scope.stepsDispatchData[step.id].index = index;

                self.fulfillmentService.getFulfillmentStepDefaultBranches(fulfillment.id, step.id)
                  .then((branches: BranchModel[]) => {
                    $scope.stepsDispatchData[step.id].branchIds = _.map(branches, 'id');
                  })
                // $scope.stepsDispatchData[step.id].isPerServiceOrTask = step.pickup ? 'perTask' : 'perService';
                $scope.stepsDispatchData[step.id].pickupDate = $scope.stepSelectedDate(step, 'pickupDate', $scope.stepsDispatchData[step.id].index);
                $scope.stepsDispatchData[step.id].destinationDate = $scope.stepSelectedDate(step, 'destinationDate', $scope.stepsDispatchData[step.id].index);

                if ($scope.enforceTimeSpecificDispatchWindow) {
                  $scope.stepsDispatchData[step.id].freeStyleMinTimeWindowRange = stepSettings.freestyleTimeWindowMinRange;
                  $scope.stepsDispatchData[step.id].freestyleTimeWindowMaxRange = stepSettings.freestyleTimeWindowMaxRange;
                }

                $scope.stepsDispatchData[step.id].defaultFullDayForServiceDispatch = stepSettings.defaultFullDayForServiceDispatch;
                $scope.stepsDispatchData[step.id].defaultDispatchByTaskFullDaySettings = stepSettings.defaultDispatchByTaskFullDaySettings;


                if ($scope.defaultDispatchType === 'FreeStyle' && stepSettings.includeFreeStyle) {
                  $scope.stepsDispatchData[step.id].optionsType = 'FreeStyle'
                }

                if ($scope.defaultDispatchType === 'TimeSlot' && stepSettings.includeTimeSlots) {
                  $scope.stepsDispatchData[step.id].optionsType = 'TimeSlot'
                }

                if ($scope.defaultDispatchType === 'DynamicTimeSlot' && stepSettings.includeDynamicTimeSlots) {
                  $scope.stepsDispatchData[step.id].optionsType = 'DynamicTimeSlot'
                }

                if (!$scope.stepsDispatchData[step.id].optionsType) {
                  if (stepSettings.includeFreeStyle) {
                    $scope.stepsDispatchData[step.id].optionsType = 'FreeStyle'
                  }
                  if (stepSettings.includeTimeSlots) {
                    $scope.stepsDispatchData[step.id].optionsType = 'TimeSlot'
                  }
                  if (stepSettings.includeDynamicTimeSlots) {
                    $scope.stepsDispatchData[step.id].optionsType = 'DynamicTimeSlot'
                  }
                }


                // $scope.stepsDispatchData[step.id].optionsType = $scope.defaultDispatchType;
                if (step.type === $scope.fulfillmentStepType.Operation) {
                  $scope.stepsDispatchData[step.id].isPerServiceOrTask = DispatchTimeWindowMethodType.perService;
                } else if ($scope.stepsDispatchData[step.id].optionsType === QuoteType.DynamicTimeSlot) {
                  $scope.stepsDispatchData[step.id].isPerServiceOrTask = DispatchTimeWindowMethodType.perService;
                } else {
                  $scope.stepsDispatchData[step.id].isPerServiceOrTask = $scope.defaultDispatchStepTimeWindowMethod;
                }

                if ($scope.stepsDispatchData[step.id].optionsType === QuoteType.DynamicTimeSlot) {
                  $scope.stepsDispatchData[step.id].dynamicQuoteFromDate = self.moment().valueOf() - $scope.stepsDispatchData[step.id].destinationDate ?
                    self.moment().valueOf() : $scope.stepsDispatchData[step.id].destinationDate;
                  $scope.stepsDispatchData[step.id].dynamicQuoteToDate = self.moment($scope.stepsDispatchData[step.id].dynamicQuoteFromDate).add(10, 'day').endOf('day').valueOf();
                }
                $scope.stepsDispatchData[step.id].workingDays = 1;

                promises.push($scope.getStepDispatchTimeRanges(step));
              })

              self.$q.all(promises).then(() => {
                $scope.setStepsTimes();
              })
            })
        })()

        $scope.isInDateRange = (step, from, to, isOrigin) => {
          if (!from && !to) {
            return true;
          }
          if (isOrigin) {
            if (!_.get(step, 'pickup.notBefore')) {
              return true;
            }
            if (self.moment(from).isBetween(step.pickup?.notBefore, step.pickup?.notAfter, null, '[]')
              && self.moment(to).isBetween(step.pickup?.notBefore, step.pickup?.notAfter, null, '[]')) {
              return true;
            }
          } else {
            if (!_.get(step, 'destination.notBefore')) {
              return true;
            }
            if (self.moment(from).isBetween(step.destination?.notBefore, step.destination?.notAfter, null, '[]')
              && self.moment(to).isBetween(step.destination?.notBefore, step.destination?.notAfter, null, '[]')) {
              return true;
            }
          }
          return false;
        }

        $scope.setDestinationMinimumDate = (step) => {

          if ($scope.stepsDispatchData[step.id].optionsType === "FreeStyle") {
            if ($scope.stepsDispatchData[step.id].isPerServiceOrTask === 'perTask') {
              $scope.stepsDispatchData[step.id].pickupFullDayTimeWindow = $scope.stepsDispatchData[step.id].defaultDispatchByTaskFullDaySettings.defaultFullDayForPickupTask;
              $scope.stepsDispatchData[step.id].destinationFullDayTimeWindow = $scope.stepsDispatchData[step.id].defaultDispatchByTaskFullDaySettings.defaultFullDayForDestinationTask;


              if ($scope.stepsDispatchData[step.id].defaultDispatchByTaskFullDaySettings.defaultFullDayForPickupTask) {
                $scope.stepsDispatchData[step.id].pickupNotBefore = self.moment($scope.stepsDispatchData[step.id].pickupDate).startOf('day').valueOf();
                $scope.stepsDispatchData[step.id].pickupNotAfter = self.moment($scope.stepsDispatchData[step.id].pickupDate).endOf('day').valueOf();
              }

              if ($scope.stepsDispatchData[step.id].defaultDispatchByTaskFullDaySettings.defaultFullDayForDestinationTask) {
                $scope.stepsDispatchData[step.id].destinationNotBefore = self.moment($scope.stepsDispatchData[step.id].destinationDate).startOf('day').valueOf();
                $scope.stepsDispatchData[step.id].destinationNotAfter = self.moment($scope.stepsDispatchData[step.id].destinationDate).endOf('day').valueOf();
              }

            } else {
              $scope.stepsDispatchData[step.id].destinationFullDayTimeWindow = $scope.stepsDispatchData[step.id].defaultFullDayForServiceDispatch;

              if ($scope.stepsDispatchData[step.id].defaultFullDayForServiceDispatch) {
                $scope.stepsDispatchData[step.id].destinationNotBefore = self.moment($scope.stepsDispatchData[step.id].destinationDate).startOf('day').valueOf();
                $scope.stepsDispatchData[step.id].destinationNotAfter = self.moment($scope.stepsDispatchData[step.id].destinationDate).endOf('day').valueOf();
              }
            }
          }

          step.destinationMinimumDate = ($scope.stepsDispatchData[step.id].isPerServiceOrTask === 'perTask' ? $scope.stepsDispatchData[step.id].pickupDate : ($scope.stepsDispatchData[step.id].index > 0 ? $scope.stepsDispatchData[fulfillment.fulfillmentSteps[$scope.stepsDispatchData[step.id].index - 1].id].destinationDate : undefined));
          $scope.modifyStepsData(step);

          // if ($scope.stepsDispatchData[step.id].optionsType === QuoteType.TimeSlot) {
          //   $scope.getStepDispatchTimeRanges(step);
          // }
        }

        $scope.setPickupMinimumTimeCanBeSelected = (step) => {
          return step.index > 0 ? $scope.stepsDispatchData[fulfillment.fulfillmentSteps[step.index - 1].id].destinationNotBefore : undefined;
        }

        $scope.isDestinationTimeslotInPickUpTimeslotRange = (obj, time) => {
          return self.moment(time).isBetween(obj.pickupNotBefore, obj.pickupNotAfter, null, '()');
        }

        $scope.onTimeRangeChange = (step, isPickup) => {
          if (isPickup) {
            $scope.stepsDispatchData[step.id].pickupNotBefore = $scope.stepsDispatchData[step.id].pickupSelectedTimeRange.notBefore;
            $scope.stepsDispatchData[step.id].pickupNotAfter = $scope.stepsDispatchData[step.id].pickupSelectedTimeRange.notAfter;
            $scope.stepsDispatchData[step.id].destinationSelectedTimeRange = $scope.selectDestinationTimeRange($scope.stepsDispatchData[step.id].pickupNotBefore, $scope.stepsDispatchData[step.id].destinationTimeRanges);
            $scope.stepsDispatchData[step.id].destinationNotBefore = _.get($scope.stepsDispatchData[step.id].destinationSelectedTimeRange, 'notBefore', undefined);
            $scope.stepsDispatchData[step.id].destinationNotAfter = _.get($scope.stepsDispatchData[step.id].destinationSelectedTimeRange, 'notAfter', undefined);
          } else {
            $scope.stepsDispatchData[step.id].destinationNotBefore = $scope.stepsDispatchData[step.id].destinationSelectedTimeRange.notBefore;
            $scope.stepsDispatchData[step.id].destinationNotAfter = $scope.stepsDispatchData[step.id].destinationSelectedTimeRange.notAfter;
          }
          $scope.stepsDispatchData[step.id].isPickupDateOutOfRange = !$scope.isInDateRange(fulfillment.fulfillmentSteps[$scope.stepsDispatchData[step.id].index], $scope.stepsDispatchData[step.id].pickupNotBefore, $scope.stepsDispatchData[step.id].pickupNotAfter, true);
          $scope.stepsDispatchData[step.id].isDestinationDateOutOfRange = !$scope.isInDateRange(fulfillment.fulfillmentSteps[$scope.stepsDispatchData[step.id].index], $scope.stepsDispatchData[step.id].destinationNotBefore, $scope.stepsDispatchData[step.id].destinationNotAfter, false);
          $scope.recalculateStepsSelectedTimeRangesOnPriorStepSelectedTimeRangeChange($scope.stepsDispatchData[step.id]);
          $scope.onCheckStepSelectState(step.id);
        }

        $scope.onBranchesChange = (step, branchIds) => {
          $scope.stepsDispatchData[step.id].branchIds = branchIds;
        }

        $scope.onDynamicQuoteDateChange = (step, from, to) => {
          $scope.stepsDispatchData[step.id].dynamicTimeSlotOption = undefined;
          if (from) {
            $scope.stepsDispatchData[step.id].dynamicQuoteFromDate = from;
            if (from > $scope.stepsDispatchData[step.id].dynamicQuoteToDate) {
              $scope.stepsDispatchData[step.id].dynamicQuoteToDate = from;
            }
          }
          if (to) {
            $scope.stepsDispatchData[step.id].dynamicQuoteToDate = to
          }
          $scope.getStepDispatchTimeRanges(step);
        }

        $scope.onDynamicTimeRangeChange = (step) => {
          if ($scope.stepsDispatchData[step.id].type !== $scope.fulfillmentStepType.Operation) {
            $scope.stepsDispatchData[step.id].pickupNotBefore = $scope.stepsDispatchData[step.id].dynamicTimeSlotOption.pickup?.notBefore;
            $scope.stepsDispatchData[step.id].pickupNotAfter = $scope.stepsDispatchData[step.id].dynamicTimeSlotOption.pickup?.notAfter;
          } else {
            $scope.stepsDispatchData[step.id].pickupNotBefore = undefined;
            $scope.stepsDispatchData[step.id].pickupNotAfter = undefined;
          }
          $scope.stepsDispatchData[step.id].destinationNotBefore = _.get($scope.stepsDispatchData[step.id].dynamicTimeSlotOption, 'destination.notBefore', undefined);
          $scope.stepsDispatchData[step.id].destinationNotAfter = _.get($scope.stepsDispatchData[step.id].dynamicTimeSlotOption, 'destination.notAfter', undefined);

          $scope.stepsDispatchData[step.id].isPickupDateOutOfRange = !$scope.isInDateRange(fulfillment.fulfillmentSteps[$scope.stepsDispatchData[step.id].index], $scope.stepsDispatchData[step.id].pickupNotBefore, $scope.stepsDispatchData[step.id].pickupNotAfter, true);
          $scope.stepsDispatchData[step.id].isDestinationDateOutOfRange = !$scope.isInDateRange(fulfillment.fulfillmentSteps[$scope.stepsDispatchData[step.id].index], $scope.stepsDispatchData[step.id].destinationNotBefore, $scope.stepsDispatchData[step.id].destinationNotAfter, false);
          $scope.recalculateStepsSelectedTimeRangesOnPriorStepSelectedTimeRangeChange($scope.stepsDispatchData[step.id]);

          $scope.onCheckStepSelectState(step.id);
        }

        $scope.recalculateStepsSelectedTimeRangesOnPriorStepSelectedTimeRangeChange = (currentModifiedStep) => {
          _.forOwn($scope.stepsDispatchData, (value) => {
            if ((value.index > currentModifiedStep.index || value.index === fulfillment.fulfillmentSteps.length - 1) && value.index !== 0) {
              if (value.optionsType === QuoteType.TimeSlot) {
                value.pickupSelectedTimeRange = $scope.selectPickupTimeRange($scope.stepsDispatchData[fulfillment.fulfillmentSteps[value.index - 1].id], value.pickupTimeRanges, value.pickupSelectedTimeRange, fulfillment.fulfillmentSteps[value.index - 1].id);
                value.pickupNotBefore = _.get(value.pickupSelectedTimeRange, 'notBefore', undefined);
                value.pickupNotAfter = _.get(value.pickupSelectedTimeRange, 'notAfter', undefined);
                value.destinationSelectedTimeRange = value.isPerServiceOrTask === 'perService' ? $scope.selectDestinationTimeRange(value.pickupNotBefore, value.destinationTimeRanges, value.destinationSelectedTimeRange, true) :
                  $scope.selectDestinationTimeRange(value.pickupNotBefore, value.destinationTimeRanges, value.destinationSelectedTimeRange, false);
                value.destinationNotBefore = _.get(value.destinationSelectedTimeRange, 'notBefore', undefined);
                value.destinationNotAfter = _.get(value.destinationSelectedTimeRange, 'notAfter', undefined);
              } else if (value.optionsType === QuoteType.FreeStyle) {
                value.pickupNotBefore = $scope.isFirstTimeStampAfterSecondTimeStamp(value.pickupNotBefore, $scope.stepsDispatchData[fulfillment.fulfillmentSteps[value.index - 1].id].destinationNotBefore) ? value.pickupNotBefore : $scope.stepsDispatchData[fulfillment.fulfillmentSteps[value.index - 1].id].destinationNotBefore;
                value.pickupNotAfter = $scope.isFirstTimeStampAfterSecondTimeStamp(value.pickupNotAfter, value.pickupNotBefore) ? value.pickupNotAfter : value.pickupNotBefore;

                if (value.type !== $scope.fulfillmentStepType.Operation) {
                  value.destinationNotBefore = $scope.isFirstTimeStampAfterSecondTimeStamp(value.destinationNotBefore, value.pickupNotAfter) ? value.destinationNotBefore : value.pickupNotAfter;
                  value.destinationNotAfter = $scope.isFirstTimeStampAfterSecondTimeStamp(value.destinationNotAfter, value.destinationNotBefore) ? value.destinationNotAfter : value.destinationNotBefore;
                }
              }
              value.isPickupDateOutOfRange = !$scope.isInDateRange(fulfillment.fulfillmentSteps[value.index], value.pickupNotBefore, value.pickupNotAfter, true);
              value.isDestinationDateOutOfRange = !$scope.isInDateRange(fulfillment.fulfillmentSteps[value.index], value.destinationNotBefore, value.destinationNotAfter, false);
            }
          })
        }

        $scope.onToggleStepSection = (step) => {
          $scope.stepsDispatchData[step.id].isSectionOpen = !$scope.stepsDispatchData[step.id].isSectionOpen;
        }

        $scope.showErrorMessage = (step) => {
          return !($scope.stepsDispatchData[step.id].pickupNotBefore &&
            $scope.stepsDispatchData[step.id].pickupNotAfter &&
            $scope.stepsDispatchData[step.id].destinationNotBefore &&
            $scope.stepsDispatchData[step.id].destinationNotAfter);
        }

        // $scope.canDispatch = $scope._isDispatchActive()();

        $scope.onDateChange = (obj, ref, isOrigin, date, step) => {
          obj[ref] = date;

          if (isOrigin) {
            obj[ref] = self.moment(date).startOf('day').valueOf();
            obj.destinationMinimumDate = (obj.isPerServiceOrTask === 'perTask' ? obj.pickupDate : (step.index > 0 ? $scope.stepsDispatchData[fulfillment.fulfillmentSteps[obj.index - 1].id].destinationDate : undefined));
            if (obj.pickupDate > obj.destinationDate) {
              obj.destinationDate = self.moment(obj.pickupDate).endOf('day').valueOf();
            }
            obj.pickupNotBefore = self.moment(obj.pickupNotBefore).set({
              year: self.moment(date).year(),
              month: self.moment(date).month(),
              date: self.moment(date).date()
            }).valueOf();
            obj.pickupNotAfter = self.moment(obj.pickupNotAfter).set({
              year: self.moment(date).year(),
              month: self.moment(date).month(),
              date: self.moment(date).date()
            }).valueOf();

            if (obj.pickupNotBefore > obj.destinationNotBefore || _.isUndefined(obj.destinationNotBefore)) {
              obj.destinationNotBefore = angular.copy(obj.pickupNotBefore);
              // obj.destinationNotAfter = angular.copy(obj.destinationNotAfter || obj.pickupNotAfter);
              obj.destinationNotAfter = angular.copy(obj.pickupNotAfter || self.moment(obj.destinationNotBefore).endOf('day').valueOf());
              obj.destinationDate = self.moment(date).endOf('day').valueOf();
              obj.isDestinationDateOutOfRange = !$scope.isInDateRange(step, obj.destinationNotBefore, obj.destinationNotAfter, isOrigin);
            }
            obj.isPickupDateOutOfRange = !$scope.isInDateRange(step, obj.pickupNotBefore, obj.pickupNotAfter, isOrigin);
          } else {
            obj[ref] = self.moment(date).endOf('day').valueOf();
            obj.destinationNotBefore = self.moment(obj.destinationNotBefore).set({
              year: self.moment(date).year(),
              month: self.moment(date).month(),
              date: self.moment(date).date()
            }).valueOf();
            obj.destinationNotAfter = self.moment(obj.destinationNotAfter).set({
              year: self.moment(date).year(),
              month: self.moment(date).month(),
              date: self.moment(date).date()
            }).valueOf();
            if (obj.destinationNotBefore < obj.pickupNotBefore) {
              obj.pickupDate = self.moment(obj.destinationDate).startOf('day').valueOf();
              obj.pickupNotBefore = angular.copy(obj.destinationNotBefore);
            }
            obj.isDestinationDateOutOfRange = !$scope.isInDateRange(step, obj.destinationNotBefore, obj.destinationNotAfter, isOrigin);
          }
          $scope.recalculateStepsSelectedTimeRangesOnPriorStepSelectedTimeRangeChange(obj);
          if ($scope.stepsDispatchData[step.id].optionsType !== "FreeStyle") {
            let promises = [];
            $scope.stepsDispatchData[step.id].disabled = true;
            promises.push($scope.getStepDispatchTimeRanges(step, self.moment(obj.pickupDate).startOf('day').valueOf(), self.moment(obj.destinationDate).endOf('day').valueOf()));
            self.$q.all(promises).then(() => {
              $scope.setStepsTimes();
            })
          }
          $scope.onCheckStepSelectState(step.id);
          $scope.modifyStepsData(obj);
        }

        $scope.onCheckStepSelectState = (stepId) => {
          if (($scope.stepsDispatchData[stepId].type === $scope.fulfillmentStepType.Operation || $scope.stepsDispatchData[stepId].isPerServiceOrTask === 'perService')
            && $scope.stepsDispatchData[stepId].destinationNotBefore && $scope.stepsDispatchData[stepId].destinationNotAfter) {
            $scope.selectedStepsIds[stepId] = true;
          } else if (!!$scope.stepsDispatchData[stepId].pickupNotBefore && !!$scope.stepsDispatchData[stepId].pickupNotAfter &&
            !!$scope.stepsDispatchData[stepId].destinationNotBefore && !!$scope.stepsDispatchData[stepId].destinationNotAfter) {
            $scope.selectedStepsIds[stepId] = true;
          }
        }

        $scope.modifyStepsData = (currentModifiedStep) => {
          let promises = []
          _.forOwn($scope.stepsDispatchData, (value, key, index) => {
            if (value.index > currentModifiedStep.index) {
              if (value.isPerServiceOrTask === 'perTask') {
                if (self.moment($scope.stepsDispatchData[fulfillment.fulfillmentSteps[value.index - 1].id].destinationDate).startOf('day').valueOf() > value.pickupDate) {
                  value.pickupDate = self.moment($scope.stepsDispatchData[fulfillment.fulfillmentSteps[value.index - 1].id].destinationDate).startOf('day').valueOf();
                  if (value.pickupDate > value.destinationDate) {
                    value.destinationDate = self.moment(value.pickupDate).endOf('day').valueOf();
                  }
                }
              } else {
                if (self.moment($scope.stepsDispatchData[fulfillment.fulfillmentSteps[value.index - 1].id].destinationDate).startOf('day').valueOf() > value.destinationDate) {
                  value.destinationDate = self.moment($scope.stepsDispatchData[fulfillment.fulfillmentSteps[value.index - 1].id].destinationDate).startOf('day').valueOf();
                }
              }
              promises.push($scope.getStepDispatchTimeRanges($scope.fulfillmentSteps[value.index], self.moment(value.pickupDate).startOf('day').valueOf(), self.moment(value.destinationDate).endOf('day').valueOf()));
            }
          })
          self.$q.all(promises).then(() => {
            $scope.setStepsTimes();
          })
        }

        $scope.stepPickupMinimumDate = (step) => {
          return step.index > 0 ? $scope.stepsDispatchData[fulfillment.fulfillmentSteps[step.index - 1].id].destinationDate : undefined;
        }

        $scope.stepDestinationMinimumDate = (step) => {
          return step.isPerServiceOrTask === 'perService' ? (step.index > 0 ? $scope.stepsDispatchData[fulfillment.fulfillmentSteps[step.index - 1].id].destinationDate : undefined) : step.pickupDate;
        }

        $scope.onFreeStyleTimeChange = (obj, ref, time, step) => {
          obj[ref] = time;

          if (ref === 'pickupNotBefore' && (obj.pickupNotAfter <= time || ((obj.pickupNotAfter - time) / (1000 * 60 * 60)) < obj.freeStyleMinTimeWindowRange)) {
            obj.pickupNotAfter = self.moment(time + (obj.freeStyleMinTimeWindowRange || 0) * 1000 * 60 * 60).valueOf()
          } else if (ref === 'destinationNotBefore' && (obj.destinationNotAfter <= time || ((obj.destinationNotAfter - time) / (1000 * 60 * 60)) < obj.freeStyleMinTimeWindowRange)) {
            obj.destinationNotAfter = self.moment(time + (obj.freeStyleMinTimeWindowRange || 0) * 1000 * 60 * 60).valueOf()
          }

          if (ref === 'pickupNotAfter' && (obj.pickupNotBefore >= time || ((Math.abs(obj.pickupNotBefore - time)) / (1000 * 60 * 60)) < obj.freeStyleMinTimeWindowRange)) {
            obj.pickupNotAfter = undefined;
            $timeout(0).then(() => {
              obj.pickupNotAfter = self.moment(obj.pickupNotBefore + (obj.freeStyleMinTimeWindowRange || 0) * 1000 * 60 * 60).valueOf()
              self.fulfillmentAlertsService.crossedMinTimeWindowRangeInfo();
            })
          } else if (ref === 'destinationNotAfter' && (obj.destinationNotBefore >= time || ((Math.abs(obj.destinationNotBefore - time)) / (1000 * 60 * 60)) < obj.freeStyleMinTimeWindowRange)) {
            obj.destinationNotAfter = undefined
            $timeout(0).then(() => {
              obj.destinationNotAfter = self.moment(obj.destinationNotBefore + (obj.freeStyleMinTimeWindowRange || 0) * 1000 * 60 * 60).valueOf()
              self.fulfillmentAlertsService.crossedMinTimeWindowRangeInfo();
            })
          }

          if (ref === 'pickupNotAfter' && (obj.pickupNotBefore >= time || ((Math.abs(obj.pickupNotBefore - time)) / (1000 * 60 * 60)) > obj.freestyleTimeWindowMaxRange)) {
            obj.pickupNotAfter = undefined;
            $timeout(0).then(() => {
              obj.pickupNotAfter = self.moment(obj.pickupNotBefore + (obj.freestyleTimeWindowMaxRange || 0) * 1000 * 60 * 60).valueOf()
              self.fulfillmentAlertsService.crossedMaxTimeWindowRangeInfo();
            })
          } else if (ref === 'destinationNotAfter' && (obj.destinationNotBefore >= time || ((Math.abs(obj.destinationNotBefore - time)) / (1000 * 60 * 60)) > obj.freestyleTimeWindowMaxRange)) {
            obj.destinationNotAfter = undefined
            $timeout(0).then(() => {
              obj.destinationNotAfter = self.moment(obj.destinationNotBefore + (obj.freestyleTimeWindowMaxRange || 0) * 1000 * 60 * 60).valueOf()
              self.fulfillmentAlertsService.crossedMaxTimeWindowRangeInfo();
            })
          }

          if (ref === 'pickupNotBefore' || ref === 'pickupNotAfter') {
            obj.isPickupDateOutOfRange = !$scope.isInDateRange(step, obj.pickupNotBefore, obj.pickupNotAfter, true);
          } else {
            obj.isDestinationDateOutOfRange = !$scope.isInDateRange(step, obj.destinationNotBefore, obj.destinationNotAfter, false);
          }
          if (ref === 'pickupNotBefore' && (obj.destinationNotBefore <= time)) {
            obj.destinationNotBefore = self.moment(time).valueOf();
            obj.destinationNotAfter = self.moment(time + (obj.freeStyleMinTimeWindowRange || 0) * 1000 * 60 * 60).valueOf()
          }
          $scope.recalculateStepsSelectedTimeRangesOnPriorStepSelectedTimeRangeChange($scope.stepsDispatchData[step.id]);
          $scope.onCheckStepSelectState(step.id);
        }

        $scope.onToggleSelected = (stepId) => {
          $scope.selectedStepsIds[stepId] = !$scope.selectedStepsIds[stepId];
          $scope.stepsDispatchData[stepId].isSectionOpen = !!$scope.selectedStepsIds[stepId];

          if (!$scope.selectedStepsIds[stepId]) {
            _.forOwn($scope.stepsBlockedByIdsMap, (blockingIds, blockedId) => {
              if (_.includes(blockingIds, stepId)) {
                $scope.selectedStepsIds[blockedId] = false;
              }
            })
          }

          $scope.recalculateStepsSelectedTimeRangesOnPriorStepSelectedTimeRangeChange($scope.stepsDispatchData[stepId]);
          // $scope.canDispatch = $scope._isDispatchActive();
        }

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              _.forOwn($scope.selectedStepsIds, (value, key, index) => {
                let step = {};
                $scope.stepsDispatchData[key].errorMessage = undefined;
                if (!value) {
                  return;
                }

                if ($scope.stepsDispatchData[key].isPerServiceOrTask === 'perService') {
                  if ((!_.get($scope.stepsDispatchData[key], 'destinationNotBefore') ||
                    !_.get($scope.stepsDispatchData[key], 'destinationNotAfter'))) {
                    $scope.stepsDispatchData[key].errorMessage = 'Schedule required'
                    $scope.stepsDispatchData[key].isSectionOpen = true;
                    return;
                  }
                  if ($scope.stepsDispatchData[key].optionsType === QuoteType.FreeStyle && !$scope.stepsDispatchData[key].destinationFullDayTimeWindow && $scope.enforceTimeSpecificDispatchWindow &&
                    (($scope.stepsDispatchData[key].freeStyleMinTimeWindowRange && (($scope.stepsDispatchData[key].destinationNotAfter - $scope.stepsDispatchData[key].destinationNotBefore) / (1000 * 60 * 60)).toFixed(1) < $scope.stepsDispatchData[key].freeStyleMinTimeWindowRange) ||
                      ($scope.stepsDispatchData[key].freestyleTimeWindowMaxRange && (($scope.stepsDispatchData[key].destinationNotAfter - $scope.stepsDispatchData[key].destinationNotBefore) / (1000 * 60 * 60)).toFixed(1) > $scope.stepsDispatchData[key].freestyleTimeWindowMaxRange))
                  ) {
                    $scope.stepsDispatchData[key].errorMessage = `Delivery minimum time window range is ${$scope.stepsDispatchData[key].freeStyleMinTimeWindowRange ? $scope.stepsDispatchData[key].freeStyleMinTimeWindowRange + ' hours' : 'unlimited'} and maximum is ${$scope.stepsDispatchData[key].freestyleTimeWindowMaxRange ? $scope.stepsDispatchData[key].freestyleTimeWindowMaxRange + ' hours' : 'unlimited'}`
                    $scope.stepsDispatchData[key].isSectionOpen = true;
                    return;
                  }
                } else {
                  if (!_.get($scope.stepsDispatchData[key], 'destinationNotBefore') ||
                    !_.get($scope.stepsDispatchData[key], 'destinationNotAfter') ||
                    !_.get($scope.stepsDispatchData[key], 'pickupNotBefore') ||
                    !_.get($scope.stepsDispatchData[key], 'pickupNotAfter')) {
                    $scope.stepsDispatchData[key].errorMessage = 'Schedule required'
                    $scope.stepsDispatchData[key].isSectionOpen = true;
                    return;
                  }
                  if ($scope.stepsDispatchData[key].optionsType === QuoteType.FreeStyle) {
                    if (!$scope.stepsDispatchData[key].pickupFullDayTimeWindow && $scope.enforceTimeSpecificDispatchWindow &&
                      (($scope.stepsDispatchData[key].freeStyleMinTimeWindowRange && (($scope.stepsDispatchData[key].pickupNotAfter - $scope.stepsDispatchData[key].pickupNotBefore) / (1000 * 60 * 60)) < $scope.stepsDispatchData[key].freeStyleMinTimeWindowRange) ||
                        ($scope.stepsDispatchData[key].freestyleTimeWindowMaxRange && (($scope.stepsDispatchData[key].pickupNotAfter - $scope.stepsDispatchData[key].pickupNotBefore) / (1000 * 60 * 60)) > $scope.stepsDispatchData[key].freestyleTimeWindowMaxRange))) {
                      $scope.stepsDispatchData[key].errorMessage = `Pick-up minimum time window range is ${$scope.stepsDispatchData[key].freeStyleMinTimeWindowRange ? $scope.stepsDispatchData[key].freeStyleMinTimeWindowRange + ' hours' : 'unlimited'} and maximum is ${$scope.stepsDispatchData[key].freestyleTimeWindowMaxRange ? $scope.stepsDispatchData[key].freestyleTimeWindowMaxRange + ' hours' : 'unlimited'}`
                      $scope.stepsDispatchData[key].isSectionOpen = true;
                      return;
                    }
                    if (!$scope.stepsDispatchData[key].destinationFullDayTimeWindow && $scope.enforceTimeSpecificDispatchWindow &&
                      (($scope.stepsDispatchData[key].freeStyleMinTimeWindowRange && (($scope.stepsDispatchData[key].destinationNotAfter - $scope.stepsDispatchData[key].destinationNotBefore) / (1000 * 60 * 60)) < $scope.stepsDispatchData[key].freeStyleMinTimeWindowRange) ||
                        ($scope.stepsDispatchData[key].freestyleTimeWindowMaxRange && (($scope.stepsDispatchData[key].destinationNotAfter - $scope.stepsDispatchData[key].destinationNotBefore) / (1000 * 60 * 60)) > $scope.stepsDispatchData[key].freestyleTimeWindowMaxRange))) {
                      $scope.stepsDispatchData[key].errorMessage = `Delivery minimum time window range is ${$scope.stepsDispatchData[key].freeStyleMinTimeWindowRange ? $scope.stepsDispatchData[key].freeStyleMinTimeWindowRange + ' hours' : 'unlimited'} and maximum is ${$scope.stepsDispatchData[key].freestyleTimeWindowMaxRange ? $scope.stepsDispatchData[key].freestyleTimeWindowMaxRange + ' hours' : 'unlimited'}`
                      $scope.stepsDispatchData[key].isSectionOpen = true;
                      return;
                    }
                  }
                }

                if ($scope.stepsDispatchData[key].isPerServiceOrTask === 'perService' && $scope.stepsDispatchData[key].optionsType !== QuoteType.DynamicTimeSlot) {
                  step['pickupNotBefore'] = $scope.stepsDispatchData[key].destinationNotBefore;
                  step['pickupNotAfter'] = $scope.stepsDispatchData[key].destinationNotAfter;
                } else {
                  step['pickupNotBefore'] = $scope.stepsDispatchData[key].pickupNotBefore;
                  step['pickupNotAfter'] = $scope.stepsDispatchData[key].pickupNotAfter;
                }
                step['destinationNotBefore'] = $scope.stepsDispatchData[key].destinationNotBefore;
                step['destinationNotAfter'] = $scope.stepsDispatchData[key].destinationNotAfter;

                step['supplierName'] = "Bringoz";
                step['provider'] = "Bringoz";
                step['subType'] = "Dispatch";

                if ($scope.stepsDispatchData[key].optionsType === QuoteType.DynamicTimeSlot) {
                  step['quoteDetails'] = $scope.stepsDispatchData[key].dynamicTimeSlotOption;
                  if ($scope.stepsDispatchData[key].type === $scope.fulfillmentStepType.Operation) {
                    step['pickupNotBefore'] = undefined;
                    step['pickupNotAfter'] = undefined;
                  }
                }

                step['quoteType'] = $scope.stepsDispatchData[key].optionsType

                if ($scope.stepsDispatchData[key].branchIds) {
                  step['manualBranchIds'] = $scope.stepsDispatchData[key].branchIds
                }

                if (!!$scope.stepsDispatchData[key].pickupLocationId) {
                  step['pickupLocation'] = {
                    id: $scope.stepsDispatchData[key].pickupLocationId,
                    locationType: $scope.stepsDispatchData[key].pickupLocationType,
                  }
                }

                if (!!$scope.stepsDispatchData[key].dropoffLocationId) {
                  step['destinationLocation'] = {
                    id: $scope.stepsDispatchData[key].dropoffLocationId,
                    locationType: $scope.stepsDispatchData[key].dropoffLocationType,
                  }
                }


                // $scope.stepsDispatchData[key].zoneId = $scope.timeZoneId;

                // if ($scope.stepsDispatchData[key].isPerServiceOrTask === 'perService' && $scope.stepsDispatchData[key].optionsType !== 'DynamicTimeSlot') {
                //   $scope.stepsDispatchData[key].pickupNotBefore = $scope.stepsDispatchData[key].destinationNotBefore;
                //   $scope.stepsDispatchData[key].pickupNotAfter = $scope.stepsDispatchData[key].destinationNotAfter;
                // }

                $scope.isFinished = false;
                $scope.stepsDispatchData[key].loading = true;
                $scope.isDispatching = true;
                self.fulfillmentService.dispatchStep(fulfillment.id, key, step)
                  .then((res) => {
                    $scope.selectedStepsIds[key] = false;
                    $scope.stepsDispatchData[key].dispatched = true;
                  })
                  .catch((error) => {
                    $scope.stepsDispatchData[key].error = true;
                  })
                  .finally(() => {
                    $scope.stepsDispatchData[key].loading = false;
                    $scope.isFinished = true;
                    _.forOwn($scope.stepsDispatchData, (data) => {
                      if (!!data.loading) {
                        $scope.isFinished = false;
                      }
                    })

                    if (!!$scope.isFinished && _.size($scope.stepsDispatchData) === 1) {
                      self.$mdDialog.hide();
                    }

                  })

              });
            } else {
              self.fulfillmentAlertsService.dispatchStepRequiredError();
            }
          }
        };

        $scope.onDone = () => {
          self.$mdDialog.hide();
        }

        $scope.getSelectedStepsIdsList = () => {
          return Object.keys($scope.selectedStepsIds)
            .filter(key => $scope.selectedStepsIds[key]);
        }

        $scope.getDispatchButtonText = () => {
          const selectedStepsIdsList = $scope.getSelectedStepsIdsList();
          if (selectedStepsIdsList.length === 1) {
            const stepIndex = $scope.fulfillmentSteps.findIndex((s) => {
              return s.id === selectedStepsIdsList[0];
            })
            return `${$translate.instant('Dispatch Step')} ${stepIndex + 1}`;
          }
          else if (selectedStepsIdsList.length > 1) {
            return $translate.instant('Dispatch Selected Steps');
          } else {
            return $translate.instant('Dispatch');
          }

        }

        $scope._isDispatchActive = () => {
          let isActive = false;
          _.forOwn($scope.selectedStepsIds, (value, key) => {
            if (!!value) {
              isActive = true;
              return;
            }
          })

          _.forEach(fulfillment.fulfillmentSteps, (s) => {

            if (!_.includes($scope.selectedStepsIds, s.id)) {
              return;
            }

            if ((!$scope.stepsDispatchData[s.id]?.pickupLocationId && !s.pickup?.location?.address && s.type !== 'Operation') ||
              (!$scope.stepsDispatchData[s.id]?.dropoffLocationId && !s.destination?.location?.address) && $scope.selectedStepsIds[s.id]) {
              isActive = false;
            }

          })

          return isActive;
        }

      },
      targetEvent: event,
      clickOutsideToClose: false,
      fullscreen: true
    })
  }

  dispatchStepExternal(fulfillmentId, step, event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/dispatch-step-external.html').default,
      controller: function ($scope) {

        $scope.step = step;
        $scope.isOnDemand = false;
        $scope.tplProviders = self.splitService.getSupportedThreePlProviders();
        $scope.minDate = self.moment().valueOf();

        $scope.isLoadingQuotes = false;
        // $scope.selectedTplProvider = ThreePLProviderType.Uber;
        if ($scope.tplProviders?.length) {
          $scope.selectedTplProvider = $scope.tplProviders[0];
        }
        $scope.date = self.moment().valueOf();
        $scope.notBefore = self.moment().valueOf();
        $scope.notAfter = self.moment().endOf('day').valueOf();
        $scope.selectedQuote = undefined;
        $scope.quotes = undefined;
        $scope.threePlExtraData = {};
        $scope.cancel = self.$mdDialog.cancel;

        // ******************************
        // External methods
        // ******************************

        $scope.getQuotes = () => {
          if (!$scope.notBefore || !$scope.notAfter || !$scope.selectedTplProvider) {
            return;
          }

          $scope.quotes = undefined;
          $scope.isLoadingQuotes = true;

          self.fulfillmentService.getStepDispatchTimeRanges(fulfillmentId, step.id, 'ThirdParty', $scope.selectedTplProvider, !$scope.isOnDemand ? $scope.notBefore : undefined, !$scope.isOnDemand ? $scope.notAfter : undefined)
            .then((res: any) => {
              $scope.quotes = res.stepDispatchOptions;
            })
            .finally(() => {
              $scope.isLoadingQuotes = false;
            });

        }

        $scope.getQuotes();

        $scope.onChangeIsOnDemand = () => {
          $scope.isOnDemand = !$scope.isOnDemand;
          $scope.getQuotes();
        }

        $scope.onTplProviderSelect = (selectedTplProvider) => {
          $scope.selectedTplProvider = selectedTplProvider;

          $scope.threePlExtraData = {};
          $scope.getQuotes();
        }

        $scope.onThreePlExtraDataChange = (threePlExtraData) => {
          $scope.threePlExtraData = angular.copy(threePlExtraData);
        }

        $scope.onDateChange = (selectedDate) => {
          $scope.date = selectedDate;
          $scope.notBefore = self.moment(selectedDate).startOf('day').valueOf();
          $scope.notAfter = self.moment(selectedDate).endOf('day').valueOf();
          $scope.getQuotes();
        }

        $scope.onTimeChange = (selectedTime, isFrom) => {
          if (isFrom) {
            $scope.notBefore = selectedTime;
          } else {
            $scope.notAfter = selectedTime;
          }
          $scope.getQuotes();
        }

        $scope.onSelectQuote = (selectedQuote) => {
          $scope.selectedQuote = selectedQuote;
        }

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              if ($scope.selectedTplProvider === 'Contractor') {
                $scope.threePlExtraData.type = $scope.selectedTplProvider;
                $scope.selectedQuote.threePlExtraData = $scope.threePlExtraData;
              }
              self.$mdDialog.hide($scope.selectedQuote);
            } else {
              self.fulfillmentAlertsService.dispatchStepRequiredError();
            }
          }
        };
      },
      targetEvent: event,
      clickOutsideToClose: false,
      fullscreen: true
    })
  }

  editStepsPrice(fulfillment, priceInfo) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/edit-steps-price.html').default,
      controller: function ($scope) {

        $scope.fulfillment = fulfillment;
        $scope.priceInfoCopy = angular.copy(priceInfo);
        $scope.cancel = self.$mdDialog.cancel;

        // ******************************
        // External methods
        // ******************************

        $scope.resetToDefault = () => {
          $scope.priceInfoCopy = angular.copy(priceInfo);
        }

        $scope.updateStepsPriceInfo = (priceInfo) => {
          $scope.priceInfoCopy = priceInfo;
        }

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide($scope.priceInfoCopy);
            }
          }
        };

      },
      targetEvent: event,
      clickOutsideToClose: false,
      fullscreen: true
    })
  }

  splitPackages(fulfillmentSteps, packageItem) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('../views/dialogs/split-packages.html').default,
      controller: function ($scope, splitService) {

        $scope.splitTypes = FulfillmentPackageSplitType;
        $scope.packageItemSettings = _.find(splitService.getSitePackageItems(), p => {
          return p.id === packageItem.type
        });
        $scope.splitType = $scope.packageItemSettings?.splitSettings?.splitType;
        $scope.packageItem = packageItem;
        $scope.fulfillmentStepsCopy = angular.copy(fulfillmentSteps);
        $scope.selectedPackageIndexes = [];
        $scope.selectedAction = 'toNewLegSamePickup';
        $scope.isNextSection = false;
        $scope.executionStep = undefined;
        $scope.isSplitCountIntoMultipleSteps = false;
        $scope.isSplitWeightIntoMultipleSteps = false;
        $scope.payload = {
          step: undefined,
          pickup: {
            contact: {},
            location: {
              locationType: "CUSTOM",
              address: {}
            }
          },
          items: []
        }

        $scope.filterFulfillmentSteps = () => {
          if (!$scope.weightToMove || $scope.weightPerLeg) {
            return;
          }

          $scope.fulfillmentStepsCopy = _.filter(fulfillmentSteps, s => {
            const stepPackage = _.find(s.items, i => {
              return i.id === packageItem.id
            });

            if (_.isUndefined(stepPackage)) {
              return false;
            }

            if (stepPackage.weight + $scope.weightToMove <= $scope.packageItemSettings.splitSettings.maximum) {
              return s;
            }


            // if (stepPackage.actualWeight &&
            //   (stepPackage.actualWeight + $scope.weightToMove <= $scope.packageItemSettings.splitSettings.maximum)) {
            //   return s;
            // } else if (stepPackage.weight + $scope.weightToMove <= $scope.packageItemSettings.splitSettings.maximum) {
            //   return s;
            // }
          })
        }

        $scope.setPackageData = () => {
          const packageExecutionStep = _.find($scope.executionStep.items, item => {
            return item.id === packageItem.id;
          });

          if (_.isUndefined(packageExecutionStep.actualCount)) {
            $scope.packageCount = packageExecutionStep.count;
            $scope.packageWeight = packageExecutionStep.weight
          } else {
            $scope.packageCount = packageExecutionStep.count - packageExecutionStep.actualCount;
            $scope.packageWeight = packageExecutionStep.weight * packageExecutionStep.count - packageExecutionStep.actualWeight * packageExecutionStep.actualCount
          }

          // $scope.packageCount = _.isUndefined(packageExecutionStep.actualCount) ? packageExecutionStep.count : packageExecutionStep.count - packageExecutionStep.actualCount;
          //
          // $scope.packageWeight = _.isUndefined(packageExecutionStep.actualCount) ?
          //   packageExecutionStep.weight : packageExecutionStep.weight - packageExecutionStep.actualWeight
        }

        $scope.setValidations = (executionStep) => {
          const packageExecutionStep = _.find($scope.executionStep.items, item => {
            return item.id === packageItem.id;
          });

          //If step status is completed then only gap can be moved from the step to another
          if (executionStep.status === 'Completed') {
            //Count
            // If there is actual count then what can be moved is package count - package actual count
            // Else nothing can be moved
            $scope.maximumPackagesToMove = !_.isUndefined(packageExecutionStep.actualCount) ? packageExecutionStep.count - packageExecutionStep.actualCount : 0;

            // Weight
            // If there is no actual weight on item then maximum can be moved is zero
            // Else if there is actual weight and there is no maximum weight settings on package then the maximum is package weight - package actual weight
            // Else there is actual weight and there is maximum settings hence take the smaller between the settings or package weight - package actual weight
            if (_.isUndefined(packageExecutionStep.actualWeight)) {
              $scope.maximumWeightToMove = 0;
            } else if (!_.isUndefined($scope.packageItemSettings.splitSettings.maximum)) {
              // $scope.maximumWeightToMove = packageExecutionStep.weight - packageExecutionStep.actualWeight;
              $scope.maximumWeightToMove = packageExecutionStep.weight * packageExecutionStep.count - packageExecutionStep.actualWeight * packageExecutionStep.actualCount;
            } else {
              // $scope.maximumWeightToMove = $scope.packageItemSettings.splitSettings.maximum < (packageExecutionStep.weight - packageExecutionStep.actualWeight) ?
              //   $scope.packageItemSettings.splitSettings.maximum : (packageExecutionStep.weight - packageExecutionStep.actualWeight)
              $scope.maximumWeightToMove = $scope.packageItemSettings.splitSettings.maximum < (packageExecutionStep.weight * packageExecutionStep.count - packageExecutionStep.actualWeight * packageExecutionStep.actualCount) ?
                $scope.packageItemSettings.splitSettings.maximum : (packageExecutionStep.weight * packageExecutionStep.count - packageExecutionStep.actualWeight * packageExecutionStep.actualCount);
            }

          } else {
            //Count // If there is actual count that means only the gap can be moved otherwise all count can be moved
            $scope.maximumPackagesToMove = !_.isUndefined(packageExecutionStep.actualCount) && packageExecutionStep.count - packageExecutionStep.actualCount ?
              packageExecutionStep.count - packageExecutionStep.actualCount : packageExecutionStep.count;

            //Weight
            // First check if there is maximum weight settings on the package
            // If there is no maximum weight settings
            // And actual weight does not exist on the package then the whole weight can be moved
            // Else if actual weight exists then the difference between package weight - package actual weight is what can be moved
            // If there is maximum weight settings on the package
            // And actual weight does not exist on the package then the maximum value is the smaller between settings max value or package weight
            // Else if actual weight exists then the maximum value is the smaller between max settings or package weight - package actual weight
            if (_.isUndefined($scope.packageItemSettings.splitSettings.maximum)) {
              $scope.maximumWeightToMove = _.isUndefined(packageExecutionStep.actualWeight) ?
                packageExecutionStep.weight : packageExecutionStep.weight * packageExecutionStep.count - packageExecutionStep.actualWeight * packageExecutionStep.actualCount;
            } else {
              if (_.isUndefined(packageExecutionStep.actualWeight)) {
                $scope.maximumWeightToMove = $scope.packageItemSettings.splitSettings.maximum > packageExecutionStep.weight ?
                  packageExecutionStep.weight : $scope.packageItemSettings.splitSettings.maximum
              } else {
                $scope.maximumWeightToMove = $scope.packageItemSettings.splitSettings.maximum < (packageExecutionStep.weight * packageExecutionStep.count - packageExecutionStep.actualWeight * packageExecutionStep.actualCount) ?
                  $scope.packageItemSettings.splitSettings.maximum : packageExecutionStep.weight * packageExecutionStep.count - packageExecutionStep.actualWeight * packageExecutionStep.actualCount
              }
            }

          }

          $scope.minimumWeightToMove = !_.isUndefined($scope.packageItemSettings.splitSettings.minimum) ?
            $scope.packageItemSettings.splitSettings.minimum : 1;

          $scope.countToMove = $scope.maximumPackagesToMove > 0 ? 1 : 0;
          $scope.weightToMove = $scope.maximumWeightToMove;

        }

        $scope.splitWeightPerLegCalculation = () => {
          $scope.multipleStepsWeightSplitCount = 0;
          $scope.multipleStepsWeightSplitRemainder = 0;

          if (!$scope.weightToMove || !$scope.weightPerLeg) {
            return;
          }

          $scope.multipleStepsWeightSplitCount = Math.floor($scope.weightToMove / $scope.weightPerLeg);
          $scope.multipleStepsWeightSplitRemainder = parseFloat(($scope.weightToMove % $scope.weightPerLeg).toFixed(2));

        }

        $scope.calculateOriginalStepWeightRemainder = () => {
          if ($scope.isSplitWeightIntoMultipleSteps) {
            if ($scope.multipleStepsWeightSplitRemainder >= $scope.packageItemSettings.splitSettings.minimum) {
              $scope.originalStepWeightRemainder = packageItem.weight - (($scope.multipleStepsWeightSplitCount * $scope.weightPerLeg) + $scope.multipleStepsWeightSplitRemainder)
            } else {
              $scope.originalStepWeightRemainder = packageItem.weight - ($scope.multipleStepsWeightSplitCount * $scope.weightPerLeg);
            }
          } else {
            $scope.originalStepWeightRemainder = packageItem.weight - $scope.weightToMove;
          }
        };

        if (packageItem.executionSteps.length === 1) {
          $scope.executionStep = packageItem.executionSteps[0];
          $scope.setPackageData();
          $scope.setValidations(packageItem.executionSteps[0]);

          if ($scope.splitType === FulfillmentPackageSplitType.BY_WEIGHT && !_.isUndefined($scope.packageItemSettings.splitSettings.maximum)) {
            $scope.filterFulfillmentSteps();
          }
          $scope.calculateOriginalStepWeightRemainder();
        }

        $scope.cancel = self.$mdDialog.cancel;

        // ******************************
        // External methods
        // ******************************

        $scope.onPayloadChange = (payload) => {
          $scope.payload = angular.copy(payload);
        }

        $scope.onSelectAction = (action) => {
          $scope.selectedAction = action;
          if (action === 'toExistingLeg' && $scope.isSplitWeightIntoMultipleSteps) {
            $scope.isSplitWeightIntoMultipleSteps = false;
          }
        }

        $scope.onSelectStep = (step) => {
          $scope.payload.step = step;
        }

        $scope.onSelectExecutionStep = (executionStep) => {
          $scope.executionStep = executionStep;
          $scope.setPackageData();
          $scope.setValidations(packageItem.executionSteps[0]);
          if ($scope.splitType === FulfillmentPackageSplitType.BY_WEIGHT && !_.isUndefined($scope.packageItemSettings.splitSettings.maximum)) {
            $scope.filterFulfillmentSteps();
          }
          $scope.calculateOriginalStepWeightRemainder();
        }

        $scope.onChangeCount = (countToMove) => {
          $scope.countToMove = countToMove
        }

        $scope.onChangeWeight = (weightToMove) => {
          $scope.weightToMove = weightToMove;
          if ($scope.isSplitWeightIntoMultipleSteps) {
            $scope.splitWeightPerLegCalculation();
          }
          if ($scope.splitType === FulfillmentPackageSplitType.BY_WEIGHT) {
            $scope.filterFulfillmentSteps();
          }
          $scope.calculateOriginalStepWeightRemainder();
        }

        $scope.onToggleCountPerLeg = (isSplitCountIntoMultipleSteps) => {
          $scope.isSplitCountIntoMultipleSteps = isSplitCountIntoMultipleSteps;
        }

        $scope.onToggleWeightPerLeg = (isSplitWeightIntoMultipleSteps) => {
          $scope.isSplitWeightIntoMultipleSteps = isSplitWeightIntoMultipleSteps;
          if (isSplitWeightIntoMultipleSteps) {
            $scope.weightPerLeg = $scope.weightToMove > $scope.maximumWeightToMove ? $scope.maximumWeightToMove : $scope.weightToMove
            $scope.splitWeightPerLegCalculation();
          } else {
            $scope.weightPerLeg = undefined;
          }
          $scope.calculateOriginalStepWeightRemainder();
        }

        $scope.onWeightPerLegChange = (weightPerLeg) => {
          $scope.weightPerLeg = weightPerLeg;
          $scope.splitWeightPerLegCalculation();
          $scope.calculateOriginalStepWeightRemainder();
        }

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              let data = [];
              let stepId;
              let pickup;
              if ($scope.selectedAction === 'toNewLegSamePickup') {
                pickup = $scope.executionStep.pickup;
              } else if ($scope.selectedAction === 'toExistingLeg') {
                stepId = $scope.payload.step.id
              } else {
                pickup = $scope.payload.pickup;
              }

              if ($scope.splitType === FulfillmentPackageSplitType.BY_COUNT) {
                const step = {
                  items: [{
                    id: packageItem.id,
                    count: $scope.countToMove
                  }],
                  pickup: pickup,
                  id: stepId
                }
                data.push(step);
              } else {
                if ($scope.isSplitWeightIntoMultipleSteps) {
                  let count = Math.floor($scope.multipleStepsWeightSplitCount);
                  for (let i = 1; i <= count; i++) {
                    const step = {
                      items: [{
                        id: packageItem.id,
                        weight: $scope.weightPerLeg
                      }],
                      pickup: pickup,
                      id: stepId
                    }
                    data.push(step);
                  }
                  if ($scope.multipleStepsWeightSplitRemainder > $scope.minimumWeightToMove) {
                    const step = {
                      items: [{
                        id: packageItem.id,
                        weight: $scope.multipleStepsWeightSplitRemainder
                      }],
                      pickup: pickup,
                      id: stepId
                    }
                    data.push(step);
                  }
                } else {
                  const step = {
                    items: [{
                      id: packageItem.id,
                      weight: $scope.weightToMove
                    }],
                    pickup: pickup,
                    id: stepId
                  }
                  data.push(step);
                }
              }
              self.$mdDialog.hide({data: data, executionStep: $scope.executionStep});
            }
          }
        };

      },
      targetEvent: event,
      clickOutsideToClose: false,
      fullscreen: true
    })
  }

  manualHandle(event, stepId?) {
    const self = this;
    return this.$mdDialog.show({
      template: require('./../views/dialogs/manual-handle-dialog.html').default,
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope) {

        $scope.stepId = stepId;
        $scope.note = '';

        $scope.cancel = self.$mdDialog.cancel;
        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////

        $scope.onSubmit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide($scope.note);
            }
          }
        }

      }
    });
  }

  createCancelTaskReason(serviceIds, event?, header?, entities?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/cancel-task-reason.html').default,
      controller: function ($scope, commonsService: CommonsService, $log, $mdMedia, deliveriesService: DeliveriesService) {

        $scope.isCancellationCommentMandatory = self.siteContextService.getSiteInfo().serviceCustomizedFields.cancelServiceCommentIsMandatory;
        $scope.serviceIds = serviceIds;
        $scope.header = header;
        $scope.selectedServices = undefined;
        $scope.cancelRelatedChecked = undefined;
        $scope.isRouted;
        $scope.cancellationReasonVisibilitiesType = CancellationReasonVisibilitiesType;

        $scope.entities = entities;
        $scope.actionReasonTypes = [ActionReasonEnum.Cancel];
        $scope.actionReasonVisibiltyTypes = ActionReasonVisibilityEnum;

        $scope.isMobile = !$mdMedia('gt-md');

        $scope.selectedCancellationReason = undefined;

        $scope.cancelTaskReason = {
          reason: undefined,
          externalId: undefined,
          description: undefined,
          actions: [],
          comment: undefined,
          attachments: [],
          serviceType: undefined,
          removeFromRoute: true
        }


        $scope.onChangeCancellationReason = (cancellationReason: ActionReasonModel) => {
          if (!cancellationReason) return;
          $scope.selectedCancellationReason = cancellationReason;
          $scope.cancelTaskReason.reason = cancellationReason.reason;
          $scope.cancelTaskReason.externalId = cancellationReason.externalId;
          $scope.cancelTaskReason.description = cancellationReason.description;
          $scope.cancelTaskReason.actions = cancellationReason.actions;
          $scope.cancelTaskReason.typeToCancel = cancellationReason.entityType;
        }

        $scope.onAddAttachment = () => {
          commonsService.fileUpload(self.commonsConstants.fileConstants.upload.images)
            .then((result) => {
              $scope._afterUpload(result);
            })
            .catch(function () {
              $log.info('Closed File Upload')
            })
        }

        $scope.onRemoveAttachment = (index) => {
          $scope.cancelTaskReason.attachments.splice(index, 1);
        }

        $scope._afterUpload = (uploadedResult) => {
          const imageUrl = _.get(uploadedResult, 'url'),
            mimeType = _.get(uploadedResult, 'contentType');

          if (imageUrl) {
            const attachment = {
              url: imageUrl,
              mimeType: mimeType
            };
            $scope.cancelTaskReason.attachments.push(attachment);
          }
        }

        $scope.cancel = self.$mdDialog.cancel;

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide({
                cancelReason: $scope.cancelTaskReason
              });
            }
          }
        };
      },
      targetEvent: event,
      fullscreen: true,
      clickOutsideToClose: false
    })
  }

  identificationsImages(steps: FulfillmentStepModel[], header?: string) {
    const self = this;
    this.$mdDialog.show({
      template: require('./../views/dialogs/identifications-images.html').default,
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope, $mdDialog) {
        $scope.steps = angular.copy(steps);
        $scope.header = header;
        $scope.selectedStepIndex = 0;
        $scope.simplifiedAttachmentsList = [];

        $scope._getAttachments = (step: FulfillmentStepModel, isPickupTaskInfo: boolean): string[] => {
          let attachments = [];
          const activeAttempt = step.attempts?.find((a) => {
            return a.id === step.referenceId;
          })

          if (!activeAttempt) {
            return [];
          }

          if (isPickupTaskInfo) {
            Object.entries(activeAttempt.serviceAttemptInfo?.pickupTaskInfo?.identifications).forEach(([key, value], index) => {
              if (key.includes('BlobName')) {
                attachments.push({id: value, name: key, url: undefined, purpose: 'Pickup'})
              }
            });
          } else {
            Object.entries(activeAttempt.serviceAttemptInfo?.destinationTaskInfo?.identifications).forEach(([key, value], index) => {
              if (key.includes('BlobName')) {
                attachments.push({id: value, name: key, url: undefined, purpose: 'Dropoff'})
              }
            });
          }
          return attachments;
        }

        $scope.stepsData = _.map(steps, (s: FulfillmentStepModel) => {
          return {
            id: s.id,
            attachments: ($scope._getAttachments(s, true)).concat($scope._getAttachments(s, false)),
          }
        })

        const blobNamesArray: string[] = $scope.stepsData.reduce((blobNamesList, sd: {
          id: string,
          attachments
        }) => {
          const attachmentsFlat = sd.attachments.flatMap((at) => {
            return at.id;
          })
          blobNamesList = blobNamesList.concat(attachmentsFlat);
          return blobNamesList;
        }, []);
        $scope.loading = true;
        if (blobNamesArray.length) {
          self.attachmentsService.getAttachmentsUrls(blobNamesArray)
            .then((attachmentsUrls: any[]) => {
              const mapByName = _.mapKeys(attachmentsUrls, (value, key) => {
                return value.name;
              });

              $scope.stepsData.forEach((sd) => {
                sd.attachments.forEach(da => {
                  da.url = mapByName[da.id].url;
                });
              })
            })
            .finally(() => {
              $scope.loading = false;
            });
        }

        $scope.onSelectStep = (index) => {
          $scope.selectedStepIndex = index;
        }

        $scope.cancel = () => {
          $mdDialog.cancel();
        };
      }
    });

  }

  restoreFulfillments(fulfillmentIds?, event?) {
    const self = this;
    return this.$mdDialog.show({
      template: require('./../views/dialogs/restore-fulfillment-dialog.html').default,
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope) {

        $scope.fulfillmentIds = fulfillmentIds;

        $scope.data = {
          copyStepTemplateId: false
        }
        $scope.cancel = self.$mdDialog.cancel;
        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////

        $scope.confirm = () => {
          self.$mdDialog.hide($scope.data.copyStepTemplateId);
        }

      }
    });
  }

}

angular
  .module('bringoz.admin.fulfillment')
  .service('fulfillmentDialogService', FulfillmentDialogService);
